var moment = require("moment");
var aux = require("./__aux");
var roomsLib = require("./rooms");
var cookiesLib = require("./cookies");
// var currencyConversionLib = require("./currencyConversion");
var sha1 = require("sha1");
var i18nLib = require("../i18n");
var runningBasket = 0;
var itineraryUpdate = function () { }; // Prevent strict errors
var gtm = require("./gtm");

var log = {
	info: console.log
}

var isBackpage = aux.getUrlParameter("backLink");

$("[data-server-value]").each(function () {
	$(this).val($(this).data("server-value"));
});

(function ($) {
	$.fn.removeClassByPrefix = removeClassByPrefix;
})(jQuery);

// [AS-295] Polyfill by gilmarllen
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (search, this_len) {
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

//function sleep(milliseconds) {
//    var start = new Date().getTime();
//    for (var i = 0; i < 1e7; i++) {
//        if ((new Date().getTime() - start) > milliseconds){
//            break;
//        }
//    }
//}

if (isBackpage == 1) {
	// $(document).ready(function(){
	//     $.ajax({
	//         url: window.location.href.replace("&backLink=1", ""),
	//         type: "GET",
	//         dataType: 'json',
	//         headers: {
	//             "Pragma": "no-cache",
	//             "Expires": -1,
	//             "Cache-Control": "no-cache"
	//         },
	//         success: function (data) {
	//             console.log(data);
	//             // window.location = window.location.href.replace("&backLink=1", "");
	//         }
	//     })
	//
	// })
}

function generateAllRoomsCombinations (arr) {
	if (arr.length == 1) {
		return arr[0];
	} else {
		var result = [];
		var allCasesOfRest = generateAllRoomsCombinations(arr.slice(1));

		for (var i = 0; i < allCasesOfRest.length; i++) {
			for (var j = 0; j < arr[0].length; j++) {
				result.push(arr[0][j] + allCasesOfRest[i]);
			}
		}
		return result;
	}

}

function nextOrPreviousField (pressKey, shiftKey, previousId, nextId, previousEvent, nextEvent) {
	var id;
	var event;

	if (pressKey == 9) { //tab
		if (shiftKey) { // shift+tab
			id = previousId;
			event = previousEvent;
		} else {
			id = nextId;
			event = nextEvent;
		}
	} else {
		if (pressKey == 13) { //enter
			id = nextId;
			event = nextEvent;
		}
	}

	switch (event) {
		case 'focus':
			$('#' + id).focus();
			break;
		case 'open':
			openSelect2OrFocus($('#' + id));
			break;
		default:
			$('#' + id).focus();
	}
}

function openSelect2OrFocus ($element) {
	if (!$element || $element.length === 0) {
		return;
	}

	if ($element.data('select2')) {
		$element.select2('open');
	} else {
		$element.focus();
	}
}

function fixSelect2Bugs () {

	if ($("#booking_contactForm").length == 0)
		return;

	var pressKey = -1;
	var shiftKey = false;
	var isTab = false;
	var isMouse = false;

	var previousId = "booking_firstName";
	var nextId = "booking_firstName";
	var previousEvent = "focus";
	var nextEvent = "focus";

	$(document).on('keydown', '.select2-search__field', function (e) {

		pressKey = e.keyCode ? e.keyCode : e.which ? e.which : -1;
		shiftKey = e.shiftKey;

		if (isTab) {
			nextOrPreviousField(pressKey, shiftKey, previousId, nextId, previousEvent, nextEvent);
		}

		pressKey = -1;
		shiftKey = false;

		previousId = "booking_firstName";
		nextId = "booking_firstName";
		previousEvent = "focus";
		nextEvent = "focus";

	});

	$(".contact-info--form").mousedown(function () {
		isMouse = true;
	});

	$(".contact-info--form").keydown(function () {
		isMouse = false;
	});

	//Select Focus on dropdown
	//open select2 dropdown on focus
	//not applied on IE6-11
	var isIE = /*@cc_on!@*/false || !!document.documentMode;
	if (!isIE) {
		$(document).on('focus', '.select2-selection--single', function (e) {
			var select2_open = $(this).parent().parent().siblings('select');
			openSelect2OrFocus(select2_open);
		});
	}

	//Fix next tab of select2
	$('#booking_country').select2().on("select2:close", function (e) {
		isTab = true;
		previousId = "booking_zip";
		nextId = "booking_email";
		previousEvent = "focus";
		nextEvent = "focus";

		if (isMouse && nextId) {
			$('#' + nextId).focus();
			isMouse = false;
		}

	});
	var lastId = '';
	$('[id$=personalTitle]').select2().on("select2:close", function (e) {
		isTab = true;
		var id = $(this).attr('id');
		var auxId = $(this).attr('id');
		if (id) {
			if (id === lastId) return;
			lastId = id;
			if (id == "booking_personalTitle") {
				previousId = "booking_firstName";
				previousEvent = "focus";
			} else {
				if (id == "roomInput_0_0_personalTitle") {
					previousId = "booking_email";
					previousEvent = "focus";
				} else {
					var temp = auxId.split('_');
					if (temp && temp.length == 4) {
						temp[1] = parseInt(temp[1]);
						temp[2] = parseInt(temp[2]);

						if (temp[2] == 0) {
							if (temp[1] > 0) {
								temp[1] = temp[1] - 1;
								temp[2] = $('[id^=roomInput_' + temp[1] + '][id$=year]').length - 1;
							}
						} else {
							temp[2] = temp[2] - 1;
						}
					}

					auxId = temp.join('_');
					auxId = auxId.replace('personalTitle', 'year');
					if ($('#' + auxId).length > 0) {
						previousId = auxId;
					}
					previousEvent = "open";
				}
			}

			id = id.replace('personalTitle', 'firstName');
			if (id) {
				nextId = id;
				nextEvent = "focus";
			}

			if (isMouse && id) {
				$('#' + id).focus();
				isMouse = false;
			}
		}
	});

	$('[id$=nationality]').select2().on("select2:close", function (e) {
		isTab = true;
		var id = $(this).attr('id');
		if (id) {
			if (id != lastId) {
				lastId = id;
				previousId = id.replace('nationality', 'lastName');
				id = id.replace('nationality', 'birthday');
				if (id) {
					nextId = id;
					previousEvent = "focus";
					nextEvent = "open";
				}
				if (nextId)
					$('#' + nextId).click().focus();
			};
		}
	});

	$('[id$=_month]:visible').select2().on("select2:close", function (e) {
		isTab = true;
		var id = $(this).attr('id');
		if (id) {
			if (id != lastId) {
				lastId = id;
				var value = $('#select2-' + id + '-container').attr('title')
				previousId = id.replace('month', 'nationality');
				id = id.replace('month', 'day');
				if (id) {
					nextId = id;
					previousEvent = "open";
					nextEvent = "open";
				}
				var nextIdValue = $('#select2-' + nextId + '-container').attr('title')
				if (isMouse && nextId) {
					$('#' + nextId).focus();
					// $('#' + nextId).select2('open');
					//isMouse = false;
				}
				if (isMouse && nextId && (nextIdValue === 'Day') && (value !== 'Month')) {
					openSelect2OrFocus($('#' + nextId));
				}
			};
		}
	});

	$('[id$=_day]:visible').select2().on("select2:close", function (e) {
		isTab = true;
		var id = $(this).attr('id');
		if (id) {
			var value = $('#select2-' + id + '-container').attr('title')
			lastId = id;
			previousId = id.replace('day', 'month');;
			id = id.replace('day', 'year');
			if (id) {
				nextId = id;
				previousEvent = "open";
				nextEvent = "open";
			}
			var nextIdValue = $('#select2-' + nextId + '-container').attr('title')
			if (isMouse && nextId) {
				$('#' + nextId).focus();
				// $('#' + nextId).select2('open');
				//isMouse = false;
			}
			if (isMouse && nextId && (value !== 'Day')) {
				openSelect2OrFocus($('#' + nextId));
			}
		}
	});

	$('[id$=_year]:visible').select2().on("select2:close", function (e) {
		isTab = true;
		var id = $(this).attr('id');
		if (id) {
			if (id != lastId) {
				lastId = id;
				previousId = id.replace('year', 'day');
				id = id.replace('year', 'personalTitle');
				if (id) {
					previousEvent = "open";
					var temp = id.split('_');
					var aux = id.split('_');
					if (temp && temp.length == 4) {
						temp[2] = parseInt(temp[2]) + 1;
						id = temp.join('_');
						if ($('#' + id).length > 0) {
							nextId = id;
							previousEvent = "open";
							nextEvent = "open";
						} else {
							temp = aux;
							temp[1] = parseInt(temp[1]) + 1;
							temp[2] = 0;
							id = temp.join('_');
							if ($('#' + id).length > 0) {
								nextId = id;
								previousEvent = "open";
								nextEvent = "open";
							}
							else {
								nextId = 'nextPage';
								nextEvent = 'focus';
								//isTab = false;
							}
						}
					} else {
						nextId = 'nextPage';
						nextEvent = 'focus';
					}
					if (isMouse && nextId && (nextId != 'nextPage')) {
						$('#' + nextId).focus();

						// $('#' + nextId).select2('open');
						isMouse = false;
					}
				}
			}
		}
	});
}

// [AS-701] Unselect unavailable options (nonexisting and disabled)
function unselectInvalidRooms (breakpoint) {
	$('.numbers-rooms').each((_idxS, selectElement) => {
		var $select = $(selectElement);
		var selectedVal = $select.val();
		$select.find('option:disabled').each((_idxO, optionElement) => {
			var $option = $(optionElement);
			if (!selectedVal && !$option.val() && !_idxO) { // it's the first/default empty option, and there's no other value selected
				$option.prop('selected', true);
			} else {
				$option.prop('selected', false);
			}
		});
		$select.trigger('change', { breakpoint: breakpoint });
	});
}

// [AS-187] Verify if all rooms are selected in the booking page
function checkAllRoomsSelects (tabIdx) {
	var rtn = true;
	var idx = 0;
	while (rtn) {
		var selects = $("select[name='roomCfg_" + tabIdx.toString() + "_" + idx.toString() + "'] option:selected");

		if (!selects.length)
			break;

		if (!selects.attr("value").length)
			rtn = false;

		idx = idx + 1;
	}

	return rtn;
}

function basketClear () {

	$("#booking-basket").addClass("hidden");
	$(".basket--price").addClass("hidden");
	$(".currency_converter_box").addClass("hidden");

}

$(document).ready(function () {

	// if($("#bookingId").val()) {
	//     $.ajax({
	//         url: window.location.href,
	//         type: "GET",
	//         dataType: 'json',
	//         headers: {
	//             "Pragma": "no-cache",
	//             "Expires": -1,
	//             "Cache-Control": "no-cache"
	//         },
	//         done: function () {
	//
	//         }
	//     })
	// }

	// date-mask
	var dateInputMask = function (elm) {
		elm.addEventListener('keypress', function (e) {
			if (e.keyCode < 47 || e.keyCode > 57) {
				e.preventDefault();
			}

			var len = elm.value.length;

			// If we're at a particular place, let the user type the slash
			// i.e., 12/12/1212
			if (len !== 1 || len !== 3) {
				if (e.keyCode == 47) {
					e.preventDefault();
				}
			}

			// If they don't add the slash, do it for them...
			if (len === 2) {
				elm.value += '/';
			}

			// If they don't add the slash, do it for them...
			if (len === 5) {
				elm.value += '/';
			}
		});
	};

	// Applying mask and setting up date picker and values into javascript objects
	setTimeout(function () {
		var maskableDates = $('.single-date.date-mask');
		if (maskableDates.length > 0) {
			maskableDates.each(function () {
				dateInputMask(this);
				// Force daterangepicker to initialize and set the value
				var dateElement = $(this);
				dateElement.trigger('change').trigger('blur');
			});
			// Booking guest birthday fields only; do not reset scroll on tour-question-form (hash anchors).
			if (!maskableDates.closest('#tourQuestionForm').length) {
				window.scrollTo(0, 0);
			}
		}
	}, 500);

	$('.sidepanel').on('click', '.sidepanel__change-details--link', function (event) {

		$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
		$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');

		window.location.href = $(this).attr('href');

		return false;
	})

	// AS-1076 - CJ Affiliate
	setTimeout(function () {
		let cjeventCookie = cookiesLib.getCookie("cjevent_dc");
		let cjeventExpiryCookie = cookiesLib.getCookie("expiry_cjevent");

		// We should store the expiry time of the cjevent cookie, if any, during the session
		if (cjeventCookie && !cjeventExpiryCookie) {
			// Due to momentjs limitations, we have to add 1 year and 1 month separately
			let value = moment().add(1, 'Y').add(1, 'M').add(-1, 'D').toDate(); // 13 months to expire, with less 1 day
			cookiesLib.setCookie("expiry_cjevent", value.toISOString());
		}
	}, 200);

	// Gtm events depending on basketView
	var isPaymentPage = String($('#isPaymentPage').val()) === 'true'
	var currentStep = !isPaymentPage ? $('#pageFunctions').val() : 'booking-payment'
	var scheduledEvent = gtm.loadScheduledEventFromSession(currentStep)
	if (scheduledEvent) {
		// Pushing scheduled event
		gtm.withCart(scheduledEvent)
			.push()
	} else {
		console.debug('Nothing to push from loadScheduledEventFromSession')
	}

	// ---------------------------------------------------------------------
	var myBookingFormAction = "";

	$("#findMyBookingButton").click(function () {
		myBookingFormAction = "find";
	});

	$("#forgotMyBookingButton").click(function () {
		myBookingFormAction = "forgot";
	});

	$('#myBookingForm').on('submit', function (e) {
		e.preventDefault();

		$("#myBookingFormWarning").css("display", "none");
		$("#myBookingFormSuccess").css("display", "none");

		if (myBookingFormAction == "find") {
			var lastName = $("#myBookingForm input[name=lastName_]").val();
			var bookingRef = $("#myBookingForm input[name=bookingRef]").val();

			if ((lastName == "") || (bookingRef == "")) {
				$("#myBookingFormWarning").text(i18nLib.localize("All input fields must be filled in."));
				$("#myBookingFormWarning").css("display", "block");
				return;
			}
		}

		else if (myBookingFormAction == "forgot") {
			var firstName = $("#myBookingForm input[name=firstName]").val();
			var lastName = $("#myBookingForm input[name=lastName]").val();
			var email = $("#myBookingForm input[name=email]").val();
			var travelDate = $("#myBookingForm input[name=travelDate]").val();

			if ((firstName == "") || (lastName == "") || (email == "") || (travelDate == "")) {
				$("#myBookingFormWarning").text(i18nLib.localize("All input fields must be filled in."));
				$("#myBookingFormWarning").css("display", "block");
				return;
			}
		}

		else {
			return;
		}

		var formData = $(this).serialize() + "&action=" + myBookingFormAction;
		var serviceUrl = $("#myBookingForm input[name=serviceUrl]").val();

		$.ajax({
			url: serviceUrl,
			method: 'POST',
			dataType: 'json',
			data: formData,
			success: function (data) {
				//console.log("\nService request successfully performed.");
				//console.log("response:\n\n" + JSON.stringify(data, null, '\t'));

				if (data.status == "success") {
					if (myBookingFormAction == "find") {
						window.location.href = data.pageUrl;

						/*
						var opts = {
							url: data.pageUrl,
							method: "POST",
							values: {x: 'example', y: 'abc'}
						};

						$.redirect(opts);
						*/
					}

					else if (myBookingFormAction == "forgot") {
						$("#myBookingForm input[name=firstName]").val("");
						$("#myBookingForm input[name=lastName]").val("");
						$("#myBookingForm input[name=email]").val("");
						$("#myBookingForm input[name=travelDate]").val("");

						$("#myBookingFormSuccess").text(i18nLib.localize("We've received your request and an email will be sent to you soon with your Booking Reference."));
						$("#myBookingFormSuccess").css("display", "block");
					}
				}

				else {
					if (myBookingFormAction == "find") {
						$("#myBookingFormWarning").text(i18nLib.localize("We could not find any Booking associated with that Last name and Booking Reference."))
						$("#myBookingFormWarning").css("display", "block");
					}

					else if (myBookingFormAction == "forgot") {
						$("#myBookingFormWarning").text(i18nLib.localize("Something went wrong while processing the request."))
						$("#myBookingFormWarning").css("display", "block");
					}
				}
			},
			error: function (xhr, status, error) {
				//console.log("\nService request could not be performed.");
				$("#myBookingFormWarning").text(i18nLib.localize("Something went wrong while processing the request."))
				$("#myBookingFormWarning").css("display", "block");
			}
		});
	});
	// ---------------------------------------------------------------------

	$("a.remember-link").click(function () {

		emptyMyBooking();

		if ($(".remember__form").is(":hidden")) {
			$(".remember__form").css("display", "show");
		}
		if ($(".mybooking__form--search-booking").is(":visible")) {
			$(".mybooking__form--search-booking").hide();
		}
	});
	$("a.back-link").click(function () {

		emptyMyBooking();

		if ($(".remember__form").is(":visible")) {
			$(".remember__form").hide();
		}
		if ($(".mybooking__form--search-booking").is(":hidden")) {
			$(".mybooking__form--search-booking").show();
		}
	});

	function emptyMyBooking () {
		$("#myBookingFormWarning").css("display", "none");
		$("#myBookingFormSuccess").css("display", "none");

		$("#myBookingForm input[name=lastName_]").val("");
		$("#myBookingForm input[name=bookingRef]").val("");
		$("#myBookingForm input[name=firstName]").val("");
		$("#myBookingForm input[name=lastName]").val("");
		$("#myBookingForm input[name=email]").val("");
		$("#myBookingForm input[name=travelDate]").val("");
	}


	var submitUrl = $("#nextPageUrl").val();

	fixSelect2Bugs();

	var uniqueMachineCookie = cookiesLib.getCookie("SessionID");

	if (uniqueMachineCookie == "" || uniqueMachineCookie == null || uniqueMachineCookie == undefined) {
		$.getJSON('//api.ipify.org?format=jsonp&callback=?', function (data) {
			var machineId = sha1(data.ip + (new Date().getTime()));
			cookiesLib.setCookie("SessionID", machineId, 90)
			uniqueMachineCookie = cookiesLib.getCookie("SessionID");
		});
	}
	/********BOOK NOW COOKIE PART*********/

	$("#bookNowButton, #bookNowButtonIcons, #bookNowButtonDescription").on("click", function () {

		var pageFunctions = $('#pageFunctions').val()
		var model = {
			isTour: pageFunctions === 'tour',
			getTourPrice: window.getTourPrice,
			getTourStartMonth: window.getTourStartMonth,
			getTourIs65Days: window.getTourIs65Days,
			tourAnalyticalData: window.tourAnalyticalData,
			isExperience: pageFunctions === 'experience',
			getExperiencePrice: window.getExperiencePrice,
			getExperienceStartMonth: window.getExperienceStartMonth,
			getExperienceIs65Days: window.getExperienceIs65Days,
			experienceAnalyticalData: window.experienceAnalyticalData
		}
		gtm.withCart()
			.addToCart(model)
			.push();


		var bookNow = {
			sessionId: uniqueMachineCookie,
			contentId: $("#contentId").val(),
			pageFunction: "sticky",
			startLocation: $("#startLocationId").val(),
			startDate: $("#bookingStartDateVal").val() || $("#bookingMinDate").val(),
			endDate: $("#bookingEndDateVal").val(),
			type: $("#bookingType").val(),
			adults: $("#adults").val() ? parseInt($("#adults").val()) : 2,
			children: $("#children").val() ? parseInt($("#children").val()) : 0,
			infants: $("#infants").val() ? parseInt($("#infants").val()) : 0,
			defaultRoom: $("#defaultRoom").val()
		}

		cookiesLib.setCookie("lasttour_enter_booking", window.location.href);

		(() => {
			$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
			$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');
		})()

		$(".stickybooking").slideUp(150);

		var testDate = moment(bookNow.startDate, "YYYY-MM-DD");
		if (testDate.isValid()) {
			$.ajax({
				url: $("#createBookingUrl").val(),
				type: "POST",
				dataType: 'json',
				data: {
					"data": JSON.stringify(bookNow)
				},
				success: function (data) {
					if (typeof data.errors === "undefined")
						window.location.href = $("#bookingPageUrl").val() + "?bookingId=" + data.bookingId;
					else {
						(() => {
							$("#global-overlay").addClass("hidden-L659");
							$("#global-spinner").addClass("hidden-L659");
						})()

						$(".stickybooking").slideDown(150);
					}

				},
				error: function (xhr) {
					(() => {
						$("#global-overlay").addClass("hidden-L659");
						$("#global-spinner").addClass("hidden-L659");
					})()
					$(".stickybooking").slideDown(150);
				}
			});
		}
		//event.preventDefault();
	});

	/*
	$('#myBookingForm').submit(function (event) {
		$('#returnMessenge').html("");

		$('#returnMessengeDiv').hide();
		$('#submitButton').hide();

		$.ajax({
			url: "_/service/no.seeds.as/bookingService",
			type: "GET",
			dataType: 'json',
			data: $(this).serialize(), // serializes the form's elements.
			success: function (data) {
				$('#returnMessenge').html("<p>" + data.returnText + "</p>");
				$('#returnMessengeDiv').show();
				$('#submitButton').show();
			},
			error: function (xhr) {
				console.log(xhr.responseText);
			}
		});
		event.preventDefault();
	});
	*/

	// Stickybooking Header

	var stickyHeader = $('.stickybooking--title');
	$(window).scroll(function () {
		if ($(this).scrollTop() > 250) {
			stickyHeader.addClass("open");
		}
		else {
			stickyHeader.removeClass("open");
		}
	});

	// Stickybooking
	var stickyBookingHeader = $('.stickybooking');
	$(window).scroll(function () {
		var threshold = 100; // number of pixels before bottom of page that you want to start fading
		var op = (($(document).height() - $(window).height()) - $(window).scrollTop()) / threshold;

		if ($(this).scrollTop() > 250) {
			// stickyBookingHeader.removeClass("hidden");
			if (op <= 0)
				stickyBookingHeader.addClass("hidden");
			else
				stickyBookingHeader.removeClass("hidden");
		}
		else {
			stickyBookingHeader.addClass("hidden");
		}
	});

	// Stickybooking Travelers

	if ($(window).width() < 768) {
		$('.travelers--input  input#travelers').attr("readonly", "readonly");
		$('.stickybooking').attr("style", "overflow: hidden;");
	}

	function updateStickingPrice () {
		if ($('.stickybooking').length > 0 && $("#bookingStartDateVal").val()) {
			$("#loading-wrap").removeClass("hidden");
			$("#price-wrap").addClass("hidden");
			$.ajax({
				url: $("#getTourPriceUrl").val(),
				type: "GET",
				dataType: 'json',
				data: {
					"location": $("#locationName").val(),
					"startDate": $("#bookingStartDateVal").val(),
					"endDate": $("#bookingEndDateVal").val(),
					"infants": $("#infants").val() || 0,
					"children": $("#children").val() || 0,
					"adults": $("#adults").val() || 1
				},
				success: function (data) {
					if (data.experiencePrice) {
						var priceTourBooking = $("#priceTourBooking");
						priceTourBooking.text(data.tourPrice);
						priceTourBooking.html(data.tourPrice);
						priceTourBooking.attr('data-original-price-text', data.tourPrice);
						priceTourBooking.data('originalPriceText', data.tourPrice);
						var priceTourBookingWrapper = priceTourBooking.parent();

						window.isPreorder = String(data.preOrder) === 'true'

						// Global functions from js/authentic/exchangeCurrencies.js
						var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession();
						if (exchangeRateCurrency && priceTourBookingWrapper[0]) {
							window.switchExchangeRateCurrency(priceTourBookingWrapper[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate);
						}
					}
					$("#loading-wrap").addClass("hidden");
					$("#price-wrap").removeClass("hidden");
				},
				error: function (xhr) {
					console.log(xhr.responseText);
				}
			});
		}
	}
	$('.travelers--input input').on("change", updateStickingPrice);

	function updateBookingInputs (e, params) {
		params = params || { skip: [] };
		params.skip = params.skip || [];
		if (params.skip.indexOf('updateBookingInputs') !== -1) {
			return true; // Keep bubbling
		}
		e.preventDefault();
		if ($(".numbers--rooms--tabs").length) {
			$(".numbers--rooms--tabs").addClass("hidden");
		}
		if ($(".loading-spinner").length) {
			$(".loading-spinner").removeClass("hidden");
		}
		var buttonType = $(this).data("value");
		var inputType = $(this).parent().parent().data("booking-type");
		var currentVal = parseInt($('input[data-booking-input=' + inputType + "]").val());
		var minVal = parseInt($('input[data-booking-input=' + inputType + "]").attr("min"));
		var maxVal = parseInt($('input[data-booking-input=' + inputType + "]").attr("max"));

		var newVal = currentVal;
		if (e.data.action == "buttons") {
			if (buttonType == "increase") {
				newVal = currentVal + 1;
			} else {
				newVal = currentVal - 1;
			}
		} else if (e.data.action == "change") {
			if (!isNaN(newVal) && newVal < minVal) {
				newVal = minVal;
			} else if (!isNaN(newVal) && newVal > maxVal) {
				newVal = maxVal;
			}
		}


		if (!isNaN(newVal) && (newVal >= minVal && newVal <= maxVal)) {
			$('input[data-booking-input=' + inputType + "]").val(newVal);
		} else if (!isNaN(newVal) < minVal) {
			$('input#booking-input-' + inputType).val(minVal);
		} else if (!isNaN(newVal) > maxVal) {
			$('input#booking-input-' + inputType).val(maxVal);
		}

		var travelersInput = $("#travelers");
		var travelers = [];

		var url = window.location.href.split('?')[0];

		$(".travelers--dropdown input[data-booking-input]").each(function () {
			var inputVal = $(this).val();
			var inputType = $(this).parent().data("booking-type");
			var singularLabel = $(this).parent().data("singular-label");
			var plurarLabel = $(this).parent().data("plural-label");
			if (inputVal > 0) {
				if (inputVal == 1) {
					travelers.push(inputVal + " " + singularLabel)
				} else {
					travelers.push(inputVal + " " + plurarLabel)
				}

				url = aux.addQSParm(url, inputType, inputVal);
			}
			travelersInput.val(travelers.join(", "));
		});

		updateStickingPrice();
		$("#bookNowButton").attr("href", url);
		if ($(".numbers--rooms--tabs").length) {
			$(".numbers--rooms--tabs").removeClass("hidden");
		}
		if ($(".loading-spinner").length) {
			$(".loading-spinner").addClass("hidden");
		}

		$('#adults').trigger("change", { 'skip': ['updateBookingInputs'] });
	}

	$(".travelers--dropdown [type=button]").on("click", { action: "buttons" }, updateBookingInputs);
	$(".travelers--dropdown [data-booking-input]").on("change", { action: "change" }, updateBookingInputs);

	$(".flexible-traveling").select2({
		placeholder: i18nLib.localize("Yes, up to 3 days")
	});

	var bookingDetails = {
		sessionId: uniqueMachineCookie,
		bookingId: $("#bookingId").val(),
		contentId: $("#contentId").val(),
		loadExperiences: $("#loadExperiences").val(),
		pageFunction: $("#pageFunctions").val(),
		nextPage: false,
		startLocation: $("#startLocationId").val(),
		startDate: $("#bookingStartDate").val() || $("#bookingStartDate").attr('value'),
		tourStartDate: $("#bookingTourStartDate").val(),
		endDate: $("#bookingEndDate").val(),
		type: $("#bookingType").val(),
		hotelCategory: $("[name='hotelCategory']").val(),
		adults: $("#adults").val() ? parseInt($("#adults").val()) : 1,
		children: $("#children").val() ? parseInt($("#children").val()) : 0,
		infants: $("#infants").val() ? parseInt($("#infants").val()) : 0,
		flexibility: $("#flexibility").val(),
		request: $("#bookingRequest").val(),
		getInTouch: $("#bookingGetInTouch").val(),
		tourplanServiceType: $("#tourplanServiceType").val(),
		fixedItinerary: ($("#fixedItinerary").val() == "true") ? true : false,
		status: $("#bookingStatus").val(),
		addedExperiences: ($("#addedAdditionalExperience").val() == "true") ? true : false,
		contact: {
			personalTitle: $("#booking_personalTitle").val(),
			firstName: $("#booking_firstName").val(),
			lastName: $("#booking_lastName").val(),
			addressLine1: $("#booking_addressLine1").val(),
			addressLine2: $("#booking_addressLine2").val(),
			city: $("#booking_city").val(),
			state: $("#booking_state").val(),
			country: $("#booking_country").val(),
			zip: $("#booking_zip").val(),
			email: $("#booking_email").val(),
			phone: $("#booking_phone").val()
		},
		room: [],
		experienceTravelers: [],
		taxType: $("#taxType").val() ? $("#taxType").val() : false,
		errors: []
	};

	function getCampaignCodeValue () {
		return ($("#campaignCode").val() || "").trim();
	}

	bookingDetails.campaignCode = getCampaignCodeValue();

	$("#bookingRequest").on("keyup", function () {
		bookingDetails.request = $("#bookingRequest").val();
	})

	$("#bookingGetInTouch").on("keyup", function () {
		bookingDetails.getInTouch = $("#bookingGetInTouch").val();
	})

	$("#bookingForm2 [data-booking-input]").each(function () {
		var inputType = $(this).data("booking-type");
		var inputVal = $(this).val();

		if ($(this).prop("checked")) {
			bookingDetails[inputType] = inputVal;
		}
	});

	$("#bookingForm3 .tab-pane.active [data-booking-select]").each(function () {
		bookingRoomUpdate(this, 818);
	});

	function bookingRoomUpdate (that, line) {

		var inputName = $(that).attr("name");
		var inputOrder = parseInt(inputName.split("_")[2]);
		var inputVal = $(that).val();

		var selectedOption = $(that).find('option:selected');
		var description = selectedOption.data('description');
		var maxAdults = selectedOption.data('max-adults');
		var maxGuests = selectedOption.data('max-guests');
		var tourplanType = selectedOption.data('tourplan-type');
		bookingDetails.roomCount = parseInt(inputName.split("_")[1]);

		for (var i = 0; i < bookingDetails.roomCount; i++) {
			if (bookingDetails.room.length < bookingDetails.roomCount) {
				bookingDetails.room.push({});
			}
		}
		bookingDetails.room[inputOrder] = {
			type: inputVal,
			description: description,
			roomType: tourplanType,
			maxAdults: maxAdults || 0,
			maxGuests: maxGuests || 0
		}
		if (bookingDetails.room.length > bookingDetails.roomCount) {
			bookingDetails.room.splice((bookingDetails.room - 1))
		}
		var totalChildren = parseInt(bookingDetails.children);
		var totalAdults = parseInt(bookingDetails.adults);
		var remainingTravelers = totalAdults + totalChildren;
		var totalTravelers = totalAdults + totalChildren;
		var remainingChildren = totalChildren;
		var allRoomsOptions = [];
		var selectedOption = "";
		var selectedOptions = [];

		$("[name^='roomCfg_" + bookingDetails.roomCount + "_']").each(function () {
			var roomIndex = $(this).attr("name").split("_")[2];
			var option = $(this).find("option:selected");
			if (roomIndex <= inputOrder) {
				if (roomIndex == 0) {
					selectedOption = (option && option.data('tourplan-type')) ? option.data("tourplan-type").trim() : "";
				}

				var numPeople = 0;
				if (option && option.data('tourplan-type')) {

					selectedOptions.push(option.data('tourplan-type').trim());

					if (option.data("tourplan-type").trim() == "SG") {
						numPeople = 1;
					}
					if (option.data("tourplan-type").trim() == "DB") {
						numPeople = 2;
					}
					if (option.data("tourplan-type").trim() == "TW") {
						numPeople = 2;
					}
					if (option.data("tourplan-type").trim() == "TR") {
						numPeople = 3;
					}
					if (option.data("tourplan-type").trim() == "DBE") {
						numPeople = 3;
					}
					if (option.data("tourplan-type").trim() == "QD") {
						numPeople = 4;
					}
				}
				remainingTravelers = remainingTravelers - numPeople;
			}

			var options = $(this).find("option");
			allRoomsOptions[roomIndex] = [];
			if (options) {
				options.each(function () {
					var item = $(this);
					if (item && item.data('tourplan-type')) {
						allRoomsOptions[roomIndex].push(item.data('tourplan-type') + ";");
					}
				});
			}

			//Reset the options other rooms
			//            if(inputOrder == 0 && roomIndex > 0) {
			//              $(this).val(null).trigger('change');
			//            }

		})

		var filteredOptions = [];
		if (selectedOption && selectedOption.length > 1) {
			var allRoomsCombinations = generateAllRoomsCombinations(allRoomsOptions);

			for (var i = 0; i < allRoomsCombinations.length; i++) {
				var options = allRoomsCombinations[i].split(';');
				var total = 0;
				var hasSeletectedOption = false
				for (var j = 0; j < options.length; j++) {
					if (options[j] == "SG") {
						total += 1;
					}
					if (options[j] == "DB") {
						total += 2;
					}
					if (options[j] == "TW") {
						total += 2;
					}
					if (options[j] == "TR") {
						total += 3;
					}
					if (options[j] == "DBE") {
						total += 3;
					}
					if (options[j] == "QD") {
						total += 4;
					}

					if ((j == 0) && options[j] == selectedOption) {
						hasSeletectedOption = true;
					}
				}

				if (total == totalTravelers && hasSeletectedOption) {
					filteredOptions.push(allRoomsCombinations[i]);
				}
			}
		}

		$("[name^='roomCfg_" + bookingDetails.roomCount + "_']").each(function () {
			var roomIndex = parseInt($(this).attr("name").split("_")[2]);
			if (roomIndex > inputOrder) {
				var options = $(this).find("option");
				options.each(function () {
					var option = $(this);
					if (option && option.data('tourplan-type')) {

						option.attr("disabled", "disabled");
						for (var i = 0; i < filteredOptions.length; i++) {
							var roomsOptions = filteredOptions[i].split(';');

							var isSelected = true;
							for (var j = 0; j < roomIndex; j++) {
								if (roomsOptions[j] == selectedOptions[j]) {
									isSelected = isSelected && true;
								} else {
									isSelected = isSelected && false;
								}
							}

							if (isSelected && (option.data("tourplan-type").trim() == roomsOptions[roomIndex].trim())) {
								option.removeAttr("disabled");
							}
						}
					}
				});

				$("[name='" + $(this).attr("name") + "']").select2({
					placeholder: i18nLib.localize("Select room type")
				})
			}
		})
	}

	if (bookingDetails.pageFunction == "booking") {
		$("#bookingForm1 [data-booking-input], #bookingForm2 [data-booking-input]").on("change", aux.debounce(function () {
			var inputType = $(this).data("booking-type") || $(this).parent().data("booking-type");
			var inputVal = $(this).val();
			// Cleaning date error upon changing hotel category
			$('#bookingForm1 #bookingErrorDate').html(null)

			// DISABLED - Sending full updated basket checkout gtm event
			// checkoutGtmEvent() // This will run on every booking-details page change, like number of travelers and rooms

			if (inputType == "date") {
				if (inputVal) {
					// CAUTION: If changing this format you also have to change the parsing on calendar.js on applyCalendar() around line 200
					bookingDetails.startDate = moment(inputVal.split(" - ")[0].trim(), "DD. MMMM YY").format("YYYY-MM-DD");
					bookingDetails.endDate = moment(inputVal.split(" - ")[1].trim(), "DD. MMMM YY").format("YYYY-MM-DD");

					if (bookingDetails.startDate == "Invalid Date") {
						bookingDetails.startDate = moment($("#bookingMinDate").val(), 'YYYY-MM-DD').format("YYYY-MM-DD");
					}

					var mStartDate = moment(bookingDetails.startDate, 'YYYY-MM-DD');
					var minStartDate = moment($("#bookingMinDate").val(), 'YYYY-MM-DD');

					if (mStartDate.isSameOrBefore(moment(), 'day') || mStartDate.isBefore(minStartDate, 'day')) {
						bookingDetails.startDate = minStartDate.format("YYYY-MM-DD");
						bookingDetails.endDate = moment(bookingDetails.startDate, 'YYYY-MM-DD').add(parseInt($("#tourDuration").val()) - 1, 'day').format("YYYY-MM-DD");
					}

					if (bookingDetails.endDate == "Invalid Date") {
						bookingDetails.endDate = moment(bookingDetails.startDate, 'YYYY-MM-DD').add(parseInt($("#tourDuration").val()) - 1, 'day').format("YYYY-MM-DD");
					}
				}

				var selectedRooms = bookingDetails && bookingDetails.room ? bookingDetails.room : [];
				bookingDetails.adults = $("#adults").val() ? parseInt($("#adults").val()) : 1;
				bookingDetails.children = $("#children").val() ? parseInt($("#children").val()) : 0;
				bookingDetails.infants = $("#infants").val() ? parseInt($("#infants").val()) : 0;

				var totalTravelers = parseInt(bookingDetails.adults);
				if (bookingDetails.type == 'tour' || bookingDetails.taxType == "room-based") {

					var largestRoomSize = $("input[data-booking='roomType']").map(function () {
						return parseInt($(this).data("max-guests"));
					}).get().sort().pop();

					$("#tabContent").html("");

					var roomsAvailables = roomsLib.getRoomsAvailables(parseInt(bookingDetails.adults), parseInt(bookingDetails.children), parseInt(bookingDetails.infants));

					for (var i = 0; i < parseInt(bookingDetails.adults); i++) {
						if (totalTravelers <= (i + 1) * largestRoomSize) {
							roomsLib.getRoomTabTemplate("#roomTabs", bookingDetails.adults, bookingDetails.children, bookingDetails.infants, (i + 1), roomsAvailables);
						} else {
							$("#roomTabs").find("#tab" + (i + 1)).parent().remove();
							$("#tabPanel" + (i + 1)).remove();
						}
					}

					$(".tab-pane").each(function () {
						var tabsWithOptions = $(this).find("option").length;
						if (tabsWithOptions == 1) {
							$(this).remove();
							$("[href='#" + $(this).attr("id") + "']").parent().remove();
						}
					});

					if ($("#roomTabs").find("[href^='#tabPanel']") && selectedRooms.length > 0) {
						$("#roomTabs #tab" + selectedRooms.length).parent().attr("class", "active");
						$($("#tabContent").find("#tabPanel" + selectedRooms.length)).addClass("active");

						$("[name^='roomCfg_" + selectedRooms.length + "_']").each(function () {
							var roomIndex = $(this).attr("name").split("_")[2];
							var options = $(this).find("option");
							options.each(function () {
								var option = $(this);
								if (option && option.data('tourplan-type') &&
									selectedRooms[roomIndex].roomType == option.data('tourplan-type')) {
									option.attr("selected", "selected");
								}
							});
						});
					}
				}

				basketUpdate(407);
			} else if (["adults", "children", "infants"].indexOf(inputType) != -1) {
				bookingDetails.adults = $("#adults").val() ? parseInt($("#adults").val()) : 1;
				bookingDetails.children = $("#children").val() ? parseInt($("#children").val()) : 0;
				bookingDetails.infants = $("#infants").val() ? parseInt($("#infants").val()) : 0;

				var totalTravelers = parseInt(bookingDetails.adults); // + parseInt(bookingDetails.children) + parseInt(bookingDetails.infants);
				// var totalTravelers = parseInt(bookingDetails.adults) + parseInt(bookingDetails.children) + parseInt(bookingDetails.infants);
				if (bookingDetails.type == 'tour' || bookingDetails.taxType == "room-based") {
					var largestRoomSize = $("input[data-booking='roomType']").map(function () {
						//return parseInt($(this).data("max-adults"));
						return parseInt($(this).data("max-guests"));
					}).get().sort().pop();

					$("#tabContent").html("");
					var roomsAvailables = roomsLib.getRoomsAvailables(parseInt(bookingDetails.adults), parseInt(bookingDetails.children), parseInt(bookingDetails.infants));

					for (var i = 0; i < parseInt(bookingDetails.adults); i++) {
						if (totalTravelers <= (i + 1) * largestRoomSize) {
							roomsLib.getRoomTabTemplate("#roomTabs", bookingDetails.adults, bookingDetails.children, bookingDetails.infants, (i + 1), roomsAvailables);
						} else {
							$("#roomTabs").find("#tab" + (i + 1)).parent().remove();
							$("#tabPanel" + (i + 1)).remove();
						}
					}

					$(".tab-pane").each(function () {
						var tabsWithOptions = $(this).find("option").length;
						if (tabsWithOptions == 1) {
							$(this).remove();
							$("[href='#" + $(this).attr("id") + "']").parent().remove();
						}
					})

					$("#bookingForm3 .tab-pane.active [data-booking-select]").each(function () {
						bookingRoomUpdate(this, 1088)
					});

					if ($("#roomTabs").find("[href^='#tabPanel']")[0]) {
						$($("#tabContent").find(".tab-pane")[0]).addClass("active")
						$("#roomTabs").find("[href^='#tabPanel']")[0].click();
					}
					var removeDivs = $("#roomTabs [role='tab']").filter(function (i) {
						return (parseInt($(this).attr("id").split("tab")[1]) > totalTravelers);
					});

					removeDivs.each(function (div) {
						$("#tabContent [aria-labelledby='" + $(this).attr("id") + "']").remove();
						$(this).parent().remove();
					});

					if ($("#roomTabs").find("li.active").length == 0) {
						$("#roomTabs #tab" + totalTravelers).parent().attr("class", "active");
						var tabQuery = "#tabContent [aria-labelledby='tab" + totalTravelers + "']";
						$(tabQuery).attr("class", "tab-pane active");
					}
				} else if (bookingDetails.type == "experience") {
					basketUpdate(440);
				}

			} else {
				// [AS-187] Removed event on field "Are you flexible with the traveling dates?"
				bookingDetails[inputType] = inputVal;
				if (inputType != "flexibility")
					basketUpdate(440);
			}
		}, 750));
		$("#bookingForm3 .tab-pane.active [data-booking-select]").each(function () {
			bookingRoomUpdate(this, 1123);
		});

		$("#bookingForm3 .tab-pane.active [data-booking-select]").on("change", function () {
			bookingRoomUpdate(this, 1127)
		});

		if ($("#bookingForm3 .tab-pane.active").length == 0) {
			$("#roomTabs li a").first().click();
		}

		$("body").on("click", "#roomTabs a", function () {

			$($(this).attr("href") + " [data-booking-select]").each(function () {
				bookingRoomUpdate(this, 1136);
			});
			var tabIdx = $(this).attr("id").slice(3);
			var check = !isNaN(parseInt(tabIdx)) ? checkAllRoomsSelects(parseInt(tabIdx)) : false;
			if (check)
				basketUpdate(462);
		});

		//        $("#roomTabs li, #roomTabs a").on("click", function () {
		//            $($(this).attr("href") + " [data-booking-select]").each(function () {
		//                bookingRoomUpdate(this, 1146);
		//            });
		//            basketUpdate(469);
		//        })

	} else if (bookingDetails.pageFunction == "booking-itinerary") {
		bookingDetails.itinerary = [];

		itineraryUpdate = function (e, line) {
			if (!e) {
				return;
			}

			var parentElement = $(e).parents("[data-booking-itinerary-day]").eq(0);
			var dayElement = $("#tour_day_" + parentElement.data("booking-itinerary-day"));
			var inputLocation = dayElement.data("booking-day-location-key");
			var inputMinNigths = dayElement.data("booking-day-min-nights");
			var inputDay = dayElement.data("booking-day-index");
			var inputTitle = dayElement.data("booking-day-title");

			bookingDetails.itinerary[parseInt(inputDay)] = {
				day: parseInt(inputDay),
				title: inputTitle,
				location: inputLocation,
				minNights: inputMinNigths,
				extraNights: $("[data-booking-input='nights'][data-day-index='" + inputDay + "'][checked='checked']").length ? parseInt($("[data-booking-input='nights'][data-day-index='" + inputDay + "'][checked='checked']").val()) : 0,
				experiencesLists: []
			};

			dayElement.attr("data-total-days", inputMinNigths);

			$("#bookingForm4 [name^='experienceList_" + parseInt(inputDay) + "']").each(function (ii, el2) {
				bookingDetails.itinerary[parseInt(inputDay)].experiencesLists[$(this).data("index")] = {
					title: $(this).data("title"),
					experiences: []
				}
			})

			var selectorString = "#bookingForm4 [data-experience-is-selected='true'][data-day-index='" + inputDay + "']";
			$(selectorString).each(function (ii, el2) {

				bookingDetails.itinerary[parseInt(inputDay)].experiencesLists[$(el2).data("experience-list-index")].experiences.push({
					experience: $(el2).attr("data-experience-id"),
					adults: $(el2).attr("data-experience-adults"),
					children: $(el2).attr("data-experience-children"),
					infants: $(el2).attr("data-experience-infants"),
					selectedDate: $(el2).attr("data-experience-selected-date"),
					shiftDays: $(el2).attr("data-experience-shift-days"),
					startTime: $(el2).attr("data-experience-start-time") || null,
					endTime: $(el2).attr("data-experience-end-time") || null,
					duration: $(el2).attr("data-experience-duration") || null,
					addedPreviously: $(el2).attr("data-experience-added-previously") || false
				});

				// if ( $(el2).attr("data-experience-overnight") == "true" )
				// {
				//     experienceExtraNights += parseInt($(el2).attr("data-experience-duration"));
				// }
			});

			// bookingDetails.itinerary[parseInt(inputDay)].experienceExtraNights = experienceExtraNights;

			var previousDay = 0;

			var previousDate = moment(bookingDetails.startDate, "YYYY-MM-DD").subtract(1, "days").format("YYYY-MM-DD");
			var totalExtraNights = 0;
			bookingDetails.itinerary.forEach(function (itDay, index) {

				var dayRefInput = $("[data-booking-day-index='" + index + "']");
				itDay.totalDays = bookingDetails.itinerary[index].minNights;
				itDay.totalDays = itDay.totalDays + bookingDetails.itinerary[index].extraNights;
				totalExtraNights = bookingDetails.itinerary[index].extraNights;
				itDay.experiencesLists.forEach(function (experienceList) {
					experienceList.experiences.forEach(function (experienceItem) {
						var el2 = $("[data-booking-itinerary-day='" + index + "'] [data-experience-id='" + experienceItem.experience + "']");
						if ($(el2).data("experience-overnight") == "true" || $(el2).data("experience-overnight") == true) {
							var experienceDuration = parseInt($(el2).attr("data-experience-duration"));
							itDay.totalDays = itDay.totalDays + experienceDuration;
							totalExtraNights = totalExtraNights + experienceDuration;
						}
					})
				})

				if ((bookingDetails.tourplanServiceType == "ES" || bookingDetails.fixedItinerary) && index == 0) {
					itDay.startDay = 1;
					itDay.endDay = (itDay.startDay + (itDay.totalDays >= 1 ? itDay.totalDays - 1 : itDay.totalDays));
					//itDay.startDate = moment(bookingDetails.startDate).subtract((bookingDetails.itinerary[index].extraNights), "days").format("DD.MM.YYYY");
					itDay.startDate = moment(bookingDetails.startDate, "YYYY-MM-DD").subtract(totalExtraNights, "days").format("DD.MM.YYYY");
					//itDay.endDate = moment(bookingDetails.startDate).format("DD.MM.YYYY");
					itDay.endDate = moment(bookingDetails.startDate, "YYYY-MM-DD").add(dayRefInput.data("booking-day-min-nights") - 1, "days").format("DD.MM.YYYY");
					bookingDetails.tourStartDate = moment(bookingDetails.startDate, "YYYY-MM-DD").subtract(totalExtraNights, "days").format("YYYY-MM-DD");;
				} else {
					itDay.startDay = dayRefInput.data("booking-day-min-nights") >= 1 ? previousDay + 1 : previousDay;
					itDay.endDay = (itDay.startDay + (itDay.totalDays >= 1 ? itDay.totalDays - 1 : itDay.totalDays));
					itDay.startDate = moment(previousDate, 'YYYY-MM-DD').add(1, "days").format("DD.MM.YYYY");
					itDay.endDate = moment(previousDate, 'YYYY-MM-DD').add((itDay.totalDays), "days").format("DD.MM.YYYY");
				}
				previousDay = itDay.endDay;

				dayRefInput.attr("data-booking-day-start", itDay.startDay);
				dayRefInput.attr("data-booking-day-end", itDay.endDay);
				dayRefInput.attr("data-total-days", itDay.totalDays);
				if (itDay.totalDays <= 1) {
					previousDate = moment(itDay.startDate, "DD.MM.YYYY").format("YYYY-MM-DD");
					$("[data-booking-itinerary-day='" + index + "']").find(".accordion--date-wrap").html("<span>" + i18nLib.localize("DAY") + "</span><span>" + itDay.startDay + "</span>")
					$("[data-booking-itinerary-day='" + index + "']").find(".accordion--month-day").html(itDay.startDate);
				} else {
					previousDate = moment(itDay.endDate, "DD.MM.YYYY").format("YYYY-MM-DD");
					$("[data-booking-itinerary-day='" + index + "']").find(".accordion--date-wrap").html("<span>" + i18nLib.localize("DAYS") + "</span><span>" + itDay.startDay + " - " + itDay.endDay + "</span>")
					$("[data-booking-itinerary-day='" + index + "']").find(".accordion--month-day").html(
						itDay.startDate + " - " +
						itDay.endDate
					)
				}

				$("[data-booking-itinerary-day='" + index + "'] [data-experience-day-selector]").each(function () {
					var experienceEl = $(this);
					var dayList = experienceEl.attr("data-experience-day-selector");

					if (!dayList || dayList == 'null' || dayList == "\'null\'" || dayList == null) //continue each
						return false;

					dayList = JSON.parse(dayList.slice(1, dayList.length - 1).replace(new RegExp("\\\\", "g"), ""));
					var dayIndex = itDay.startDay;
					dayList.forEach(function (day, dayIdx) {
						day.dayLabel = dayIndex;
						day.date = moment(itDay.startDate, "DD.MM.YYYY").add(dayIdx, "days").format("YYYY-MM-DD");
						day.dateLabel = moment(itDay.startDate, "DD.MM.YYYY").add(dayIdx, "days").format("DD.MM.YYYY");
						dayIndex++;
					});

					experienceEl.attr("data-experience-day-selector", "'" + JSON.stringify(dayList) + "'");

					if (experienceEl.attr("data-experience-is-selected")
						&& experienceEl.attr("data-experience-is-selected") == "true") {

						var expStartDate = moment(bookingDetails.itinerary[index].startDate, "DD.MM.YYYY");
						var expEndDate = moment(bookingDetails.itinerary[index].endDate, "DD.MM.YYYY")
						var expSelectedDate = moment(bookingDetails.itinerary[index].startDate, "DD.MM.YYYY");

						var shiftDays = experienceEl.attr("data-experience-shift-days") ? parseInt(experienceEl.attr("data-experience-shift-days")) : 0;
						expSelectedDate = expSelectedDate.add(shiftDays, "days");

						if (!moment(expSelectedDate).isBetween(expStartDate, expEndDate, 'day', '[]')) {
							if (expSelectedDate >= expEndDate) {
								experienceEl.attr("data-experience-selected-date", expEndDate.format("YYYY-MM-DD"));
								experienceEl.attr("data-experience-shift-days", expEndDate.diff(expStartDate, "days"));
							} else {
								experienceEl.attr("data-experience-selected-date", expStartDate.format("YYYY-MM-DD"));
								experienceEl.attr("data-experience-shift-days", 0);
							}
						} else {
							experienceEl.attr("data-experience-selected-date", expSelectedDate.format("YYYY-MM-DD"))
						}
					}
				});

				itDay.experiencesLists.forEach(function (experienceList) {
					experienceList.experiences.forEach(function (experienceItem) {
						var el2 = $("[data-booking-itinerary-day='" + index + "'] [data-experience-id='" + experienceItem.experience + "']");
						experienceItem.selectedDate = $(el2).attr("data-experience-selected-date");
						experienceItem.shiftDays = $(el2).attr("data-experience-shift-days");
					});
				});
			})

			var experienceExtraNights = 0;
			$(selectorString).each(function (ii, el2) {
				//                var expStartDate = moment( bookingDetails.itinerary[parseInt(inputDay)].startDate, "DD.MM.YYYY" );
				//                var expEndDate = moment( bookingDetails.itinerary[parseInt(inputDay)].endDate, "DD.MM.YYYY" ).format("YYYY-MM-DD");
				//                var expSelectedDate = moment( $(el2).attr("data-experience-selected-date") );
				//
				//                var diffDays = expStartDate.diff(expSelectedDate);
				//
				//                $(el2).attr("data-experience-selected-date", moment( expSelectedDate.add(moment.duration(diffDays).asDays(), 'days') ).format("YYYY-MM-DD"));

				//if ( $(el2).attr("data-experience-overnight") == "true" && moment( expSelectedDate ).isBetween( expStartDate, expEndDate, null, '[]' ))
				if ($(el2).attr("data-experience-overnight") == "true") {
					experienceExtraNights += parseInt($(el2).attr("data-experience-duration"));
				}
			});
			bookingDetails.itinerary[parseInt(inputDay)].experienceExtraNights = experienceExtraNights;

			var lastItineraryDay = bookingDetails && bookingDetails.itinerary && bookingDetails.itinerary.length
				? bookingDetails.itinerary[bookingDetails.itinerary.length - 1]
				: null;
			if (lastItineraryDay) {
				bookingDetails.endDate = moment(lastItineraryDay.endDate, "DD.MM.YYYY").format("YYYY-MM-DD");
			}
		}

		/********THIS IS TO PUT IN URL THE HASH OF THE DAY THAT IS CLICKED AND WHEN IS RELOADED WE OPEN THE DAY THAT WAS OPENED********/
		var sessionHash = sessionStorage.getItem('hash')
		if (isNotNullNorUndefined(sessionHash)) {
			$("#bookingForm4").find("[data-toggle=collapse]").each(function () {
				var collapseElement = $(this)
				if (collapseElement.data("hash-day") == sessionHash) {
					collapseElement.click();
					var collapseElementParentId = collapseElement.parent('.accordion--heading').attr('id');
					if (collapseElementParentId) document.location.hash = "#" + collapseElementParentId;
					sessionStorage.removeItem('hash');
				}
			});
		}
		// Removing the fixed spinner
		// setTimeout(function () {
		// 	// Removes the spinner added from default-page controller
		// 	$("#global-overlay").addClass("hidden");
		// 	$("#global-spinner").addClass("hidden");
		// }, 700);

		$("[id^='tour_day_']").each(function () {
			itineraryUpdate(this, 1379);
		});

		basketUpdate(559);

		$("[data-booking-input='nights']").on("change", function (e) {
			if ($("#pageFunctions").val() == "booking-itinerary" && $("#bookingStatus").val() == "CF") {
				e.preventDefault();
				return false;
			}

			var parentElement = $(this).parents("[data-booking-itinerary-day]").eq(0);
			var dayElement = $("#tour_day_" + parentElement.data("booking-itinerary-day"));
			var inputDay = dayElement.data("booking-day-index");

			if ($("[data-booking-input='nights'][data-day-index='" + inputDay + "'][checked='checked']").length > 0) {
				$("[data-booking-input='nights'][data-day-index='" + inputDay + "'][checked='checked']").removeAttr("checked");
			}

			$("[data-booking-input='nights'][value='" + $(this).val() + "'][data-day-index='" + inputDay + "']").attr("checked", "checked");

			itineraryUpdate(this, 1400);
			//basketUpdate(564);

			sessionStorage.setItem('hash', $(this).data("hash-day")); /*This is to put the hash on url to open this itinerary accordion when reload*/
			sessionStorage.setItem('scrollTop', $(window).scrollTop());
			var scrollTopPosition = sessionStorage.getItem('scrollTop');

			/*show the button "remove extra night" when some extra night is added.*/
			$(this).parent().parent().find("a#btn-remove-ExtraNight").removeClass("hidden");
			// location.reload();
			/*If the extranight was changed, it is needed to submit to update the booking*/
			// submitUrl = $("#itineraryPageUrl").val();
			bookingDetails.extraNightSubmit = true;
			submitUrl = "reload";
			$("#bookingFormSubmit").submit();
		});

		/* This event is to remove the extra night from basket and uncheck the buttons on button click */
		$("a#btn-remove-ExtraNight").on("click", function (eventC) {
			//eventC.preventDefault();
			//$(this).parent().find("[data-nights=0]").click();
			//$(this).addClass("hidden");

			var parentElement = $(this).parents("[data-booking-itinerary-day]").eq(0);
			var dayElement = $("#tour_day_" + parentElement.data("booking-itinerary-day"));
			var inputDay = dayElement.data("booking-day-index");

			if ($("[data-booking-input='nights'][data-day-index='" + inputDay + "'][checked='checked']").length > 0) {
				$("[data-booking-input='nights'][data-day-index='" + inputDay + "'][checked='checked']").removeAttr("checked");
			}

			$(this).addClass("hidden");

			sessionStorage.setItem('hash', $(this).data("hash-day")); /*This is to put the hash on url to open this itinerary accordion when reload*/
			sessionStorage.setItem('scrollTop', $(window).scrollTop());
			var scrollTopPosition = sessionStorage.getItem('scrollTop');

			/*If the extranight was changed, it is needed to submit to update the booking*/
			// submitUrl = $("#itineraryPageUrl").val() /*+ itineraryHashText*/;
			bookingDetails.extraNightSubmit = true;
			submitUrl = "reload";
			$("#bookingFormSubmit").submit();
		});

	}
	else if (bookingDetails.pageFunction == "booking-contact") {
		basketUpdate(854);
		var clearErrorsOnBlank = function () {
			var self = $(this);
			if (!self.is(":visible")) {
				return; // Ignore hidden inputs
			}
			var newVal = self.val();
			if (isNullOrUndefined(newVal) || String(newVal).trim() === '') {
				self.parents("div.form-group").eq(0).find(".help-block.with-errors").html('');
				self.parents("div.form-group").eq(0).find(".has-error").removeClass("has-error");
				self.parents("div.form-group").removeClass("has-error");
			}
		};
		$("[data-booking-input='contact']").on("change", function () {
			clearErrorsOnBlank.apply(this);
			bookingDetails.contact[$(this).attr("name")] = $(this).val();
		});
		$('[id$=_birthday]').on('change', function () {
			var self = $(this);
			var newVal = $.trim(self.val());
			var minYear = parseInt(self.data('min-year'));
			var maxYear = parseInt(self.data('max-year'));
			var format = self.data('format') || 'DD/MM/YYYY';
			var birthIdx = self.attr('id').indexOf('_birthday');
			var prefix = self.attr('id').substring(0, birthIdx);
			var date = moment(newVal, format, true);
			var errorElement = self.parents("div.form-group").eq(0).find("[id^='bookingErrorBirthday_']").eq(0);
			var day = '';
			var month = '';
			var year = '';

			errorElement.html('').hide();
			self.parents("div.form-group").eq(0).removeClass("has-error");

			if (newVal && !date.isValid()) {
				self.val('');
				errorElement.html(i18nLib.localize("Please enter the birthday in dd/mm/yyyy.")).show();
				self.parents("div.form-group").eq(0).addClass("has-error");
				$('#' + prefix + '_day').val('').trigger('change');
				$('#' + prefix + '_month').val('').trigger('change');
				$('#' + prefix + '_year').val('').trigger('change');
				return;
			}

			if (newVal) {
				newVal = date.format(format);
				day = date.format('DD');
				month = date.format('MM');
				year = date.format('YYYY');
				if (self.val() !== newVal) {
					self.val(newVal);
				}
			}

			$('#' + prefix + '_day').val(day).trigger('change');
			$('#' + prefix + '_month').val(month).trigger('change');

			// Validate year interval
			var invalidYear = false;
			if (newVal) {
				var oldVal = newVal;
				var newValMoment = moment(newVal, format, true);
				if (newValMoment.year() < minYear) {
					newValMoment.year(minYear);
				} else if (newValMoment.year() > maxYear) {
					newValMoment.year(maxYear);
				}
				newVal = newValMoment.isValid() ? newValMoment.format(format) : '';
				if (oldVal !== newVal) {
					/*
					if (moment(newVal, format).format() === "Invalid date") {
						newVal = '';
					} else {
						// picker.setStartDate(newVal);
						// picker.setEndDate(newVal);
					}
					self.val(newVal).change();
					*/
					invalidYear = true;
					$('#' + prefix + '_year').val(1000).trigger('change');
				}
			}
			if (!invalidYear) {
				$('#' + prefix + '_year').val(year).trigger('change');
			}

		});

		$("[data-booking-input='roomId']").each(function () {
			var room = {
				type: $(this).val(),
				guest: []
			}

			$("[data-room-index='" + $(this).attr("id").split("_")[1] + "']").each(function () {
				var guestId = "#roomInput_" + $(this).attr("id").split("_")[1] + "_" + $(this).attr("id").split("_")[2]
				room.guest.push({
					personalTitle: $(guestId + "_personalTitle").val(),
					firstName: $(guestId + "_firstName").val(),
					lastName: $(guestId + "_lastName").val(),
					nationality: $(guestId + "_nationality").val(),
					day: $(guestId + "_day").val(),
					month: $(guestId + "_month").val(),
					year: $(guestId + "_year").val()
				});
			})
			bookingDetails.room.push(room);
		});
		$("[data-booking-input='guest']").on("change", function () {
			var roomIndex = $(this).attr("id").split("_")[1];
			var guestIndex = $(this).attr("id").split("_")[2];
			var fieldName = $(this).attr("id").split("_")[3];
			clearErrorsOnBlank.apply(this);
			if (!bookingDetails.room[roomIndex].guest[guestIndex]) {
				bookingDetails.room[roomIndex].guest[guestIndex] = {}
			}
			bookingDetails.room[roomIndex].guest[guestIndex][fieldName] = $(this).val();
		});
	} else if (bookingDetails.pageFunction != "tour" || bookingDetails.pageFunction != "experience") {
		basketUpdate(894);
	}

	$("#bookingForm4 [data-booking-input]").each(function () {
		var dayIndex = $(this).data("day-index");
		var inputVal = $(this).val();

		if ($(this).prop("checked") && (bookingDetails && bookingDetails.itinerary && bookingDetails.itinerary.length > 0)) {
			bookingDetails.itinerary[dayIndex].selectedNights = parseInt(inputVal);
		}
	});


	var target = document.getElementById('tabContent');

	if (target) {
		// create an observer instance
		var observer = new MutationObserver(function (mutations) {
			//loop through the detected mutations(added controls)
			mutations.forEach(function (mutation) {
				//addedNodes contains all detected new controls
				if (mutation && mutation.addedNodes) {
					mutation.addedNodes.forEach(function (elm) {
						//only apply select2 to select elements
						$(elm).find(".numbers-rooms").select2({
							placeholder: i18nLib.localize("Select room type")
						}).on("change", function (_e, args) {
							var breakpoint = 'numberRoomsChangeMutationObserver'; // Prevent change event calling itself
							if (args && args.breakpoint === breakpoint) {
								return; // Skip the cascade events since a breakpoint was called inside a change event
							}

							$('#bookingErrorRooms').text(''); // Clear text before new validations
							bookingRoomUpdate(this, 1472);
							unselectInvalidRooms(breakpoint);

							var tabIdx = $(this).attr("name").split("_")[1];
							if (checkAllRoomsSelects(tabIdx))
								basketUpdate(298);
						});
					});
				}
			});
		});

		// pass in the target node, as well as the observer options
		observer.observe(target, {
			childList: true
		});

		// later, you can stop observing
		//observer.disconnect();
	}

	$(".numbers-rooms").select2({
		placeholder: i18nLib.localize("Select room type")
	}).on("change", function (_e, args) {
		var breakpoint = 'numberRoomsChangeOutside'; // Prevent change event calling itself
		if (args && args.breakpoint === breakpoint) {
			return; // Skip the cascade events since a breakpoint was called inside a change event
		}

		$('#bookingErrorRooms').text(''); // Clear text before new validations
		bookingRoomUpdate(this, 1495);
		unselectInvalidRooms(breakpoint);

		var tabIdx = $(this).attr("name").split("_")[1];
		if (checkAllRoomsSelects(tabIdx))
			basketUpdate(616);
	});

	$(".hotel--category--choose--box").on("change blur focus", "input", function () {
		var self = $(this);
		var inputElement = $(".hotel--category--choose--box input[value='" + self.val() + "']");
		var parentBox = inputElement.parents("div.hotel--category--choose--box").eq(0);
		parentBox.addClass("active");
		$(this.parentNode).find('.hotel--category--choose--box').not(this).removeClass('active');
		self.addClass('active');
	})

	$('.request--open').click(function () {
		$('.request--field').toggleClass('open');
	});

	$('.get-in-touch--open').click(function () {
		$('.request--field').toggleClass('open');
	});

	$.fn.validator.Constructor.INPUT_SELECTOR = ':input:not([type="submit"], button):enabled';
	$('#booking_contactForm').validator();
	$('#booking_contactForm input, #booking_contactForm select').on('change', function () {
		if (!$(this).parents("div.form-group").eq(0).hasClass("has-error") || $(this).val() != "") {
			$(this).parents("div.form-group").eq(0).find(".help-block.with-errors").hide();
			$(this).parents("div.form-group").eq(0).find(".has-error").removeClass("has-error");
		}
	})

	$('#getInTouchSummaryForm textarea, #getInTouchForm textarea').bind('keyup change', function () {
		if (!$(this).parents("div.form-group").eq(0).hasClass("has-error") || $(this).val() != "") {
			$(this).parents("div.form-group").eq(0).find(".help-block.with-errors").hide();
			$(this).parents("div.form-group").eq(0).find(".has-error").removeClass("has-error");
			$(this).parents("div.form-group").removeClass("has-error");
		}
	});

	$('#acceptBooking').on('change', function () {
		if (!$(this).parents("div.form-group").eq(0).hasClass("has-error") || $(this).val() != "") {
			$(this).parents("div.form-group").eq(0).find(".help-block.with-errors").hide();
			$(this).parents("div.form-group").removeClass("has-error");
		}
	})

	$(".contact-select select").select2({});


	function assignTravelers () {
		var index = $(this).attr("name").split("_")[1];
		if (!bookingDetails.experienceTravelers[index]) {
			bookingDetails.experienceTravelers.push({
				personalTitle: $("#expGuestInput_" + index + "_personalTitle").val(),
				firstName: $("#expGuestInput_" + index + "_firstName").val(),
				lastName: $("#expGuestInput_" + index + "_lastName").val(),
				nationality: $("#expGuestInput_" + index + "nationality").val(),
				birthday: $("#expGuestInput_" + index + "_birthday").val(),
				day: $("#expGuestInput_" + index + "_day").val(),
				month: $("#expGuestInput_" + index + "_month").val(),
				year: $("#expGuestInput_" + index + "_year").val()
			})
		} else {
			bookingDetails.experienceTravelers[index] = {
				personalTitle: $("#expGuestInput_" + index + "_personalTitle").val(),
				firstName: $("#expGuestInput_" + index + "_firstName").val(),
				lastName: $("#expGuestInput_" + index + "_lastName").val(),
				nationality: $("#expGuestInput_" + index + "_nationality").val(),
				birthday: $("#expGuestInput_" + index + "_birthday").val(),
				day: $("#expGuestInput_" + index + "_day").val(),
				month: $("#expGuestInput_" + index + "_month").val(),
				year: $("#expGuestInput_" + index + "_year").val()
			}
		}
	}

	$("[id^='expGuestInput_']").each(assignTravelers)

	$("[id^='expGuestInput_']").on("change", assignTravelers)

	// Go to next page removing the extras
	$(".booking-itinerary-intro .nextPage").click(function () {
		var bookingId = bookingDetails.bookingId;
		bookingDetails.addedExperiences = false; // Resetting experiences
		bookingDetails.itinerary = []; // Resetting the itinerary array

		// Call the cleaner service
		$.ajax({
			url: $("#clearItineraryExtrasUrl").val(),
			method: 'POST',
			dataType: 'json',
			data: {
				bookingId: bookingId
			},
			beforeSend: function () {
				$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
				$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');
			},
			success: function (data) {

				// Sending step gtm event
				var isPaymentPage = String($('#isPaymentPage').val()) === 'true'
				var currentStep = !isPaymentPage ? $('#pageFunctions').val() : 'booking-payment'
				gtm.withCart()
					.changeStep({ currentStep: currentStep, stepAmount: +1 })
					.push();

				// Go to next page
				var nextPageUrl = $("#nextPageUrl").val();
				if (nextPageUrl) {
					cookiesLib.setCookie("days_opened", "");
					location.href = nextPageUrl;
				}
			},
			error: function (xhr) {
				(() => {
					$("#global-overlay").addClass("hidden-L1815");
					$("#global-spinner").addClass("hidden-L1815");
				})()
				Sentry.captureMessage("clearBookingItinerary Service: " + xhr.status + " - " + xhr.statusText);
				Sentry.captureException(xhr);
			}
		});
	});

	$("#nextPage").click(function () {
		// Adjusting URL by removing the status parameter
		const beforeUrl = window.location.href
		let url = new URL(window.location.href)
		url.searchParams.delete('status')
		url = aux.clearUrlAnchor(url.toString())
		if (beforeUrl !== url) {
			window.history.replaceState(url, document.title, url)
		}

		var submitButton = $(this)
		if (submitButton.val()) {
			var submitForm = submitButton.closest('form')
			if (submitForm && submitForm.length > 0) {
				submitForm.off('onbeforesubmit');
				submitForm.on('onbeforesubmit', function () {

					var isPaymentPage = String($('#isPaymentPage').val()) === 'true'
					var currentStep = !isPaymentPage ? $('#pageFunctions').val() : 'booking-payment'

					// Send initial checkout gtm event
					checkoutGtmEvent(currentStep)

					// Schedule, if payment was successful, the full updated basket purchase gtm event
					purchaseGtmEvent(currentStep)

					// Sending step gtm event
					gtm.withCart()
						.changeStep({ currentStep: currentStep, stepAmount: +1 })
						.push();
				});
			}

			// [AS-210] Clear the cookies referent to the boxes opened in the day-by-day page
			cookiesLib.setCookie("days_opened", "");
			submitUrl = submitButton.val();
		}
		bookingDetails.nextPage = true;

	});

	$("#prevPage").click(function () {

		// var submitButton = $(this)
		// var submitForm = submitButton.closest('form')
		// if (submitForm && submitForm.length > 0) {
		// submitForm.off('onbeforesubmit');
		// submitForm.on('onbeforesubmit', function () {
		// Sending step gtm event
		// var isPaymentPage = String($('#isPaymentPage').val()) === 'true'
		// var currentStep = !isPaymentPage ? $('#pageFunctions').val() : 'booking-payment'
		// gtm.withCart()
		// .changeStep({ currentStep: currentStep, stepAmount: -1 })
		// .push();
		// });
		// }

		// [AS-210] Clear the cookies referent to the boxes opened in the day-by-day page
		cookiesLib.setCookie("days_opened", "");
		submitUrl = $(this).val();

	});


	$("#prevPageReturnTour").click(function () {
		window.location.href = $("#returnToTourPrev").val();
	});

	$("#copyContact").on("click", function () {
		if ((bookingDetails.type == "tour") || (bookingDetails.taxType == "room-based")) {
			if ($(this).prop("checked")) {
				if ($("#roomInput_0_0_title")) {
					$("#roomInput_0_0_personalTitle").val($("#booking_personalTitle").val()).trigger("change");
					$("#roomInput_0_0_nationality").val($("#booking_country").find(":selected").data("nationality")).trigger("change");
					$("#roomInput_0_0_firstName").val($("#booking_firstName").val()).trigger("change");
					$("#roomInput_0_0_lastName").val($("#booking_lastName").val()).trigger("change");
				}
			} else {
				$("#roomInput_0_0_personalTitle").val("").trigger("change");
				$("#roomInput_0_0_year").val("").trigger("change");
				$("#roomInput_0_0_month").val("").trigger("change");
				$("#roomInput_0_0_day").val("").trigger("change");
				$("#roomInput_0_0_nationality").val("").trigger("change");
				$("#roomInput_0_0_firstName").val("").trigger("change");
				$("#roomInput_0_0_lastName").val("").trigger("change");
			}
		} else if (bookingDetails.type == "experience") {
			if ($(this).prop("checked")) {
				if ($("#expGuestInput_0_personalTitle")) {
					$("#expGuestInput_0_personalTitle").val($("#booking_personalTitle").val()).trigger("change");
					$("#expGuestInput_0_nationality").val($("#booking_country").find(":selected").data("nationality")).trigger("change");
					$("#expGuestInput_0_firstName").val($("#booking_firstName").val()).trigger("change");
					$("#expGuestInput_0_lastName").val($("#booking_lastName").val()).trigger("change");
				}
			} else {
				$("#expGuestInput_0_personalTitle").val("").trigger("change");
				$("#expGuestInput_0_year").val("").trigger("change");
				$("#expGuestInput_0_month").val("").trigger("change");
				$("#expGuestInput_0_day").val("").trigger("change");
				$("#expGuestInput_0_nationality").val("").trigger("change");
				$("#expGuestInput_0_firstName").val("").trigger("change");
				$("#expGuestInput_0_lastName").val("").trigger("change");
			}
		} else {
			if ($(this).prop("checked")) {
				if ($("#roomInput_0_0_personalTitle")) {
					$("#roomInput_0_0_personalTitle").val($("#booking_personalTitle").val()).trigger("change");
					$("#expGuestInput_0_firstName").val($("#booking_firstName").val()).trigger("change");
					$("#expGuestInput_0_lastName").val($("#booking_lastName").val()).trigger("change");
				}
			} else {
				$("#roomInput_0_0_personalTitle").val("").trigger("change");
				$("#roomInput_0_year").val("").trigger("change");
				$("#roomInput_0_month").val("").trigger("change");
				$("#roomInput_0_day").val("").trigger("change");
				$("#roomInput_0_nationality").val("").trigger("change");
				$("#expGuestInput_0_firstName").val("").trigger("change");
				$("#expGuestInput_0_lastName").val("").trigger("change");
			}
			$("[id^='expGuestInput_']").each(assignTravelers)
		}
	})

	function getErrorObj (errorName, roomIndex, guestIndex) {

		if (isNotNullNorUndefined(roomIndex) && isNotNullNorUndefined(guestIndex)) {
			return {
				errorContainer: "#bookingError" + errorName + "_" + roomIndex + "_" + guestIndex,
				errorFocus: "#guestTitle_" + roomIndex + "_" + guestIndex,
				errorText: $("[data-error-container='#bookingError" + errorName + "']").val()
			}
		} else if (isNotNullNorUndefined(roomIndex) && isNullOrUndefined(guestIndex)) {
			return {
				errorContainer: "#bookingError" + errorName + "_" + roomIndex,
				errorFocus: $("[data-error-container='#bookingError" + errorName + "']").data("error-focus"),
				errorText: $("[data-error-container='#bookingError" + errorName + "']").val()
			}
		} else if (isNullOrUndefined(roomIndex) && isNotNullNorUndefined(guestIndex)) {
			return {
				errorContainer: "#bookingError" + errorName + "_" + guestIndex,
				errorFocus: "#guestTitle_" + guestIndex,
				errorText: $("[data-error-container='#bookingError" + errorName + "']").val()
			}
		} else {
			return {
				errorContainer: $("[data-error-container='#bookingError" + errorName + "']").data("error-container"),
				errorFocus: $("[data-error-container='#bookingError" + errorName + "']").data("error-focus"),
				errorText: $("[data-error-container='#bookingError" + errorName + "']").val()
			}
		}
	}

	/**
	 * We assume that adults comes first
	 */
	function checkAgeGroupByIndex (currentIndex, totalAdults) {
		return currentIndex < totalAdults;
	}

	function bookingSubmit (event) {
		event.preventDefault();
		bookingDetails.campaignCode = getCampaignCodeValue();

		//Clear errors before revalidating
		$("form").has(":input:not(:submit):visible").find(".has-error").removeClass("has-error");

		$("[id^='tour_day_']").each(function () {
			itineraryUpdate(this, 1722);
		})

		$($("#roomTabs .active a").attr("href") + " [data-booking-select]").each(function () {
			bookingRoomUpdate(this, 1664);
		});

		$("[id^='bookingError']").html("");
		window.errors = [];

		if (bookingDetails.pageFunction == "booking") {
			if (!bookingDetails.startDate || !bookingDetails.endDate) {
				errors.push(getErrorObj("Date"));
			}
			if (!bookingDetails.flexibility) {
				errors.push(getErrorObj("Flexibility"));
			}

			if (
				$("#adults").length && parseInt(bookingDetails.adults) < parseInt($("#adults").attr("min")) ||
				$("#children").length && parseInt(bookingDetails.children) < parseInt($("#children").attr("min")) ||
				$("#infants").length && parseInt(bookingDetails.infants) < parseInt($("#infants").attr("min"))
			) {
				errors.push(getErrorObj("Travelers"));
			}

			var totalAdults = parseInt(bookingDetails.adults);
			var totalChildren = parseInt(bookingDetails.children);
			var totalTravelers = totalAdults + totalChildren;

			var adultsAllowed = 0;
			var childrenAllowed = 0;
			var travelersAllowed = 0;

			bookingDetails.room.forEach(function (roomCfg) {

				travelersAllowed += parseInt(roomCfg.maxGuests);

				if (roomCfg.type != "" || roomCfg.type != null) {
					if (totalAdults < parseInt(roomCfg.maxAdults)) {
						roomCfg.maxAdults = totalAdults;
					}

					adultsAllowed = adultsAllowed + parseInt(roomCfg.maxAdults);
					childrenAllowed = childrenAllowed + (parseInt(roomCfg.maxGuests) - parseInt(roomCfg.maxAdults));
				} else {
					adultsAllowed = 0;
					childrenAllowed = 0;
				}
			})

			if (adultsAllowed > totalAdults) {
				childrenAllowed = childrenAllowed + (adultsAllowed - totalAdults);
				adultsAllowed = totalAdults;
			}

			if (bookingDetails.type == "tour") {
				if (totalTravelers > travelersAllowed) {
					errors.push(getErrorObj("Rooms"));
				}
			}
		}
		else if (bookingDetails.pageFunction == "booking-contact") {
			if (!bookingDetails.contact.personalTitle || bookingDetails.contact.personalTitle == '-1' || bookingDetails.contact.personalTitle == '') {
				errors.push(getErrorObj("Title"));
			}
			if (!bookingDetails.contact.firstName) {
				errors.push(getErrorObj("FirstName"));
			}
			if (!bookingDetails.contact.lastName) {
				errors.push(getErrorObj("LastName"));
			}
			if (!bookingDetails.contact.addressLine1) {
				errors.push(getErrorObj("AddressLine1"));
			}
			if (!bookingDetails.contact.city) {
				errors.push(getErrorObj("City"));
			}
			//            if (!bookingDetails.contact.state) {
			//                errors.push(getErrorObj("State"));
			//            }

			if (!bookingDetails.contact.country || bookingDetails.contact.country == '-1' || bookingDetails.contact.country == '') {
				errors.push(getErrorObj("Country"));
			}
			if (!bookingDetails.contact.zip) {
				errors.push(getErrorObj("Zip"));
			}
			if (!bookingDetails.contact.email) {
				errors.push(getErrorObj("Email"));
			}
			if (!bookingDetails.contact.phone) {
				errors.push(getErrorObj("Phone"));
			}
			if (submitUrl == "getInTouch" && !bookingDetails.getInTouch) {
				errors.push(getErrorObj("GetInTouch"));
			}

			var infoDefaultTravelers = {
				totalAdults: parseInt($("#numAdults").val()),
				totalChildren: parseInt($("#numChildren").val()),
				totalInfants: parseInt($("#numInfants").val()),
				adultsMinAge: parseInt($("#adultsMinAge").val()),
				childrenMinAge: parseInt($("#childrenMinAge").val()),
				infantsMinAge: parseInt($("#infantsMinAge").val()),
				adultsMaxAge: parseInt($("#adultsMaxAge").val()),
				childrenMaxAge: parseInt($("#childrenMaxAge").val()),
				infantsMaxAge: parseInt($("#infantsMaxAge").val()),
			}

			bookingDetails.infoDefaultTravelers = JSON.parse(JSON.stringify(infoDefaultTravelers));

			var roomAdults = (travelersByRoom[0] || {}).roomAdults || 0;
			var roomChildren = (travelersByRoom[0] || {}).roomChildren || 0;

			if ((bookingDetails.type == "tour") || (bookingDetails.taxType == "room-based")) {
				bookingDetails.room.forEach(function (room, roomIndex) {
					roomAdults = (travelersByRoom[roomIndex] || {}).roomAdults || 0;
					roomChildren = (travelersByRoom[roomIndex] || {}).roomChildren || 0;

					room.guest.forEach(function (guest, guestIndex) {
						if (!guest.personalTitle || guest.personalTitle == '-1' || guest.personalTitle == '') {
							errors.push(getErrorObj("Title", roomIndex, guestIndex));
						}
						if (!guest.firstName || guest.firstName == "") {
							errors.push(getErrorObj("FirstName", roomIndex, guestIndex));
						}
						if (!guest.lastName || guest.lastName == "") {
							errors.push(getErrorObj("LastName", roomIndex, guestIndex));
						}
						if (!guest.nationality || guest.nationality == '-1' || guest.nationality == '') {
							errors.push(getErrorObj("Nationality", roomIndex, guestIndex))
						}
						if (!guest.birthday || guest.birthday == '-1' || guest.birthday == '') {
							errors.push(getErrorObj("Birthday", roomIndex, guestIndex))
						} else {
							var date = guest.birthday.split("/");
							guest.year = guest.year || date[2];
							guest.month = guest.month || date[1];
							guest.day = guest.day || date[0];
						}
						if (!guest.year || guest.year == '-1' || guest.year == '') {
							errors.push(getErrorObj("Year", roomIndex, guestIndex))
						}
						if (!guest.month || guest.month == '-1' || guest.month == '') {
							errors.push(getErrorObj("Month", roomIndex, guestIndex))
						}
						if (!guest.day || guest.day == '-1' || guest.day == '') {
							errors.push(getErrorObj("Day", roomIndex, guestIndex))
						}

						if (moment(bookingDetails.startDate, "YYYY-MM-DD").isSameOrBefore(guest.year + '-' + guest.month + '-' + guest.day, 'day')) {
							//Birthday in the future
							errors.push(getErrorObj("Birthday", roomIndex, guestIndex));
							errors.push(getErrorObj("Year", roomIndex, guestIndex));
							errors.push(getErrorObj("Month", roomIndex, guestIndex));
							errors.push(getErrorObj("Day", roomIndex, guestIndex));
						}

						if (guest.year && guest.year != '-1' && guest.year != '' && guest.month && guest.month != '-1' && guest.month != '' && guest.day && guest.day != '-1' && guest.day != '') {
							var guestAge = parseInt(moment(bookingDetails.startDate, "YYYY-MM-DD").diff(guest.year + '-' + guest.month + '-' + guest.day, 'years', true));

							// if (guestAge < parseInt(infoDefaultTravelers.childrenMinAge)) {
							//     infoDefaultTravelers.infants--;
							//     if (infoDefaultTravelers.infants < 0)
							//         errors.push(getErrorObj("InvalidInfantYear", roomIndex, guestIndex))

							// }
							//If it's an adult, then check age range (minimum)

							if (checkAgeGroupByIndex(guestIndex, roomAdults)) {
								if (guestAge < parseInt(infoDefaultTravelers.adultsMinAge) || guestAge > 120 /* Maximum human age */)
									errors.push(getErrorObj("InvalidAdultYear", roomIndex, guestIndex));
							} else if (checkAgeGroupByIndex(guestIndex, roomAdults + roomChildren)) {
								//If it's a child, then check age range (minimum and maximum)
								if (guestAge < parseInt(infoDefaultTravelers.childrenMinAge) || guestAge > parseInt(infoDefaultTravelers.childrenMaxAge)) {
									errors.push(getErrorObj("InvalidChildYear", roomIndex, guestIndex));
								}
							} else {
								//If it's a infant, then check age range (minimum and maximum)
								if (guestAge < parseInt(infoDefaultTravelers.infantsMinAge) || guestAge > parseInt(infoDefaultTravelers.infantsMaxAge)) {
									errors.push(getErrorObj("InvalidInfantYear", roomIndex, guestIndex));
								}
							}
						}
					})
				});
			} else if (bookingDetails.type == "experience") {
				if (bookingDetails.experienceTravelers.length == 0) {
					errors.push(getErrorObj("FirstName", null, guestIndex));
				} else {
					bookingDetails.experienceTravelers.forEach(function (guest, guestIndex) {
						if (!guest.personalTitle || guest.personalTitle == '-1' || guest.personalTitle == '') {
							errors.push(getErrorObj("Title", null, guestIndex));
						}
						if (!guest.firstName) {
							errors.push(getErrorObj("FirstName", null, guestIndex));
						}
						if (!guest.lastName) {
							errors.push(getErrorObj("LastName", null, guestIndex));
						}
						if (!guest.year || guest.year == '-1' || guest.year == '') {
							errors.push(getErrorObj("Year", null, guestIndex))
						}
						if (!guest.month || guest.month == '-1' || guest.month == '') {
							errors.push(getErrorObj("Month", null, guestIndex));
						}
						if (!guest.day || guest.day == '-1' || guest.day == '') {
							errors.push(getErrorObj("Day", null, guestIndex))
						}

						if (moment(bookingDetails.startDate, "YYYY-MM-DD").isSameOrBefore(guest.year + '-' + guest.month + '-' + guest.day, 'day')) {
							//Birthday in the future
							errors.push(getErrorObj("Year", null, guestIndex));
							errors.push(getErrorObj("Month", null, guestIndex));
							errors.push(getErrorObj("Day", null, guestIndex));
						}

						if (guest.year && guest.year != '-1' && guest.year != '' && guest.month && guest.month != '-1' && guest.month != '' && guest.day && guest.day != '-1' && guest.day != '') {
							var guestAge = parseInt(moment(bookingDetails.startDate, "YYYY-MM-DD").diff(guest.year + '-' + guest.month + '-' + guest.day, 'years', true));

							// if (guestAge < parseInt(infoDefaultTravelers.childrenMinAge)) {
							//     infoDefaultTravelers.infants--;
							//     if (infoDefaultTravelers.infants < 0)
							//         errors.push(getErrorObj("InvalidInfantYear", guestIndex))
							// }
							//If it's an adult, then check age range (minimum)

							if (checkAgeGroupByIndex(guestIndex, roomAdults)) {
								if (guestAge < parseInt(infoDefaultTravelers.adultsMinAge) || guestAge > 120 /* Maximum human age */)
									errors.push(getErrorObj("InvalidAdultYear", null, guestIndex));
							} else if (checkAgeGroupByIndex(guestIndex, roomAdults + roomChildren)) {
								//If it's a child, then check age range (minimum and maximum)
								if (guestAge < parseInt(infoDefaultTravelers.childrenMinAge) || guestAge > parseInt(infoDefaultTravelers.childrenMaxAge)) {
									errors.push(getErrorObj("InvalidChildYear", null, guestIndex));
								}
							} else {
								//If it's a infant, then check age range (minimum and maximum)
								if (guestAge < parseInt(infoDefaultTravelers.infantsMinAge) || guestAge > parseInt(infoDefaultTravelers.infantsMaxAge)) {
									errors.push(getErrorObj("InvalidInfantYear", null, guestIndex));
								}
							}
						}

					})
				}
			}
		}
		else if (bookingDetails.pageFunction == "booking-summary") {
			if (!$("#acceptBooking").prop("checked")) {
				errors.push(getErrorObj("Accept"))
			}
			var summaryRequest = $("body #bookingSummaryRequest").val();
			if (summaryRequest && errors.length == 0) {
				(() => {
					$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
					$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');
				})()
				$.ajax({
					url: $("#getInTouchService").val(),
					method: 'POST',
					dataType: 'json',
					data: {
						bookingSummaryRequest: String(summaryRequest),
						bookingId: $("#bookingId").val()
					},
					error: function (xhr) {
						console.log(xhr.responseText);
						return false; //Prevent submit
					}
				});
			}
		}

		if (errors.length > 0) {
			errors.forEach(function (error) {
				if (!$(error.errorContainer).parent().hasClass("has-error")) {
					$(error.errorContainer).parent().addClass("has-error");
				}
				$(error.errorContainer).show();
				$(error.errorContainer).html(error.errorText);
			});

			$('body, html').animate({
				scrollTop: parseInt($(errors[0].errorFocus).offset().top)
			}, 800, function () {
				window.location.hash = errors[0].errorFocus;
			});

			// [AS-188] Removed the basket update in the contact page when has invalid field in the form
			//basketUpdate(1197)
		}

		if (errors.length === 0 && event.target) {
			console.debug('trigger from ' + $(event.target).prop('id'))
			$(event.target).trigger('onbeforesubmit')
		}

		if ($("#bookingUpdateUrl").val() && errors.length == 0) {
			bookingDetails.getBasket = false;

			(() => {
				$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
				$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');
			})()

			// Send updateTimer to backend
			bookingDetails.previousRequestTime = sessionStorage.getItem('bookingUpdatePreviousRequestTime')

			$.ajax({
				url: $("#bookingUpdateUrl").val(),
				type: "POST",
				dataType: 'json',
				data: {
					data: JSON.stringify(bookingDetails)
				}, // serializes the form's elements.
				success: function (data) {
					if (String(data.outdatedBookingViewModel) !== 'true') {
						// Update local updateTime on frontend
						sessionStorage.setItem('bookingUpdatePreviousRequestTime', data.newRequestTime)
					}

					// Scroll to error message from cancel
					setTimeout(function () {
						if ('URL' in window) {
							var currentUrl = new URL(window.location.href);
							var isCancel = currentUrl.searchParams.has('status', 'Cancel')
							var termsBookingSummary = $('.terms--wrap.terms-booking-summary')
							if (isCancel && termsBookingSummary && termsBookingSummary.length > 0) {
								const scrollTopTarget = termsBookingSummary.offset().top
								$('body, html').animate({
									scrollTop: parseInt(scrollTopTarget)
								}, 800, function () {
									window.location.hash = '#error-booking-summary'
								});
							}
						}
					}, 200);

					if (data && data.errors && data.errors.length > 0) {
						data.errors.forEach(function (error) {
							/*contactAux is a variable that is filled when there is a error in the age of travelers in bookingUpdate*/
							if (error.contactAux) {
								/* bookingErrorInvalidDate defaults to #bookingErrorDate on bookingForm1; on contact pages guest DOB uses #bookingErrorBirthday_{room}_{guest} or #bookingErrorBirthday_{guest} (experience). */
								if (error.errorName === 'bookingErrorInvalidDate') {
									error.errorContainer = '#bookingErrorBirthday' + error.contactAux;
								} else {
									error.errorContainer += error.contactAux;
								}
								error.errorFocus = '#guestTitle' + error.contactAux;
							}

							var $errContainer = $(error.errorContainer);
							if ($errContainer.length) {
								if (!$errContainer.parent().hasClass('has-error')) {
									$errContainer.parent().addClass('has-error');
								}
								$errContainer.show();
								$errContainer.html(error.errorText);
							}
						});
						var focusEl = $(data.errors[0].errorFocus);
						var scrollY = focusEl.length ? parseInt(focusEl.offset().top, 10) : 0;
						$('body, html').animate({
							scrollTop: scrollY
						}, 800, function () {
							(() => {
								$("#global-overlay").addClass("hidden-L2315");
								$("#global-spinner").addClass("hidden-L2315");
							})()

							window.location.hash = data.errors[0].errorFocus;
							basketUpdate(1223);
						});
					} else if ((data.checkoutParams || data.terminalRedirect || data.outdatedBookingViewModel) && bookingDetails.pageFunction != "booking-summary-getintouch") {
						if (data.terminalRedirect) {
							// Redirect
							setTimeout(function () {
								window.location = data.terminalRedirect;
							}, 2500)
						} else if (String(data.outdatedBookingViewModel) === 'true') {
							console.warn('WARNING: BookingViewModel is outdated. Reloading page.')
							// Clear local updateTime
							sessionStorage.removeItem('bookingUpdatePreviousRequestTime')
							window.location.reload()
							return
						} else {
							/* Open Flywire checkout - BEGIN */
							var cancelToken = data.checkoutParams.cancelToken
							delete data.checkoutParams.cancelToken

							var config = data.checkoutParams

							config.renderTimestamp = new Date().getTime()
							config.onCancel = function () {
								console.log('FLYWIRE - Checkout cancelled');

								var cancelFunc = (function (configClosure) {
									return function () {
										if ('URL' in window) {
											var cancelUrl = new URL(configClosure.returnUrl)
											cancelUrl.searchParams.delete('bookingId')
											cancelUrl.searchParams.set('status', 'cancel')
											cancelUrl.searchParams.set('token', cancelToken)
											cancelUrl.searchParams.set('renderTimestamp', configClosure.renderTimestamp)

											window.location = cancelUrl.toString()
										}
									}
								})(config)
								setTimeout(cancelFunc, 5000)
							}

							window.bookingCheckout = {}
							window.bookingCheckout.onCancel = config.onCancel
							window.bookingCheckout.flywireModal = window.FlywirePayment.initiate(config)
							window.bookingCheckout.flywireModal.render()

							/* Open Flywire checkout - END */
						}
					} else {

						if (submitUrl == "reload") {
							// Get the opened boxes
							var days_opened = [];
							$('[id^=itineraryCollapse_].in').each(function (idx, it) {
								days_opened.push($(it).attr('id').replace('itineraryCollapse_', ''));
							});
							cookiesLib.setCookie("days_opened", JSON.stringify(days_opened));
							window.location.reload(true);
						}
						else if (submitUrl == "getInTouch") {
							$.ajax({
								url: $("#getInTouchService").val(),
								method: 'POST',
								dataType: 'json',
								data: {
									bookingGetInTouch: $("body #bookingGetInTouch").val().toString(),
									contentId: $("#contentId").val(),
									name: $("#booking_firstName").val(),
									bookingUrl: $("#getintouchPage").val(),
									email: $("#booking_email").val(),
									phone: $("#booking_phone").val()
								},
								success: function (data) {
									$(".getInTouchSeccessMessage").removeClass("hidden");
									(() => {
										$("#global-overlay").addClass("hidden-L2315");
										$("#global-spinner").addClass("hidden-L2315");
									})()
									$("#bookingGetInTouch").attr("disabled", "true");
									$("#bookingGetInTouch").css("background", "#eee");
									$(".submitButton-getInTouch").attr("disabled", "true");
									$(".submitButton-getInTouch").text(i18nLib.localize("Message sent"));
									setTimeout(function () { $('.getInTouchSeccessMessage').addClass('hidden'); }, 6000);
									// window.location.reload();
								},
								error: function (xhr) {
									console.log(xhr.responseText);
								}
							});
						}
						else
							window.location = submitUrl;
					}
				},
				error: function (xhr) {
					(() => {
						$("#global-overlay").addClass("hidden-L2315");
						$("#global-spinner").addClass("hidden-L2315");
					})()
					$("#basketContainer .loading").addClass("hidden");
					$("#basketView").append("<strong class='help-block with-errors'>" + i18nLib.localize("Something went wrong! Please, contact our team.") + "</strong>");
				}
			});
		}
		return false;
	}

	$("#bookingFormSubmit").submit(bookingSubmit);

	$("#getInTouchForm").submit(function (eventSub) {
		eventSub.preventDefault();
		submitUrl = "getInTouch";
		$("#bookingFormSubmit").submit();
	});

	$("#getInTouchSummaryForm").submit(function (eventSumSub) {
		// eventSumSub.preventDefault();
		// bookingDetails.pageFunction = "booking-summary-getintouch";
		// submitUrl = "getInTouch";
		// $("#bookingFormSubmit").submit();
		eventSumSub.preventDefault();
		var errors = [];
		if (!$("#bookingGetInTouch").val()) {
			errors.push(getErrorObj("GetInTouch"));
		}

		if (errors.length > 0) {
			errors.forEach(function (error) {
				if (!$(error.errorContainer).parent().hasClass("has-error")) {
					$(error.errorContainer).parent().addClass("has-error");
				}
				$(error.errorContainer).show();
				$(error.errorContainer).html(error.errorText);
			});

			$('body, html').animate({
				scrollTop: parseInt($(errors[0].errorFocus).offset().top)
			}, 800, function () {
				window.location.hash = errors[0].errorFocus;
			});

			// [AS-188] Removed the basket update in the contact page when has invalid field in the form
			//basketUpdate(1197)
		}

		if (errors.length == 0) {
			(() => {
				$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
				$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');
			})()

			$.ajax({
				url: $("#getInTouchService").val(),
				method: 'POST',
				dataType: 'json',
				data: {
					bookingGetInTouch: $("body #bookingGetInTouch").val().toString(),
					contentId: $("#contentId").val(),
					name: $("#getintouchfirstName").val(),
					bookingUrl: $("#getintouchPage").val(),
					email: $("#getintouchEmail").val(),
					bookingId: $("#bookingId").val()
				},
				success: function (data) {
					$(".getInTouchSeccessMessage").removeClass("hidden");
					(() => {
						$("#global-overlay").addClass("hidden-L2482");
						$("#global-spinner").addClass("hidden-L2482");
					})()
					$("#bookingGetInTouch").attr("disabled", "true");
					$("#bookingGetInTouch").css("background", "#eee");
					$(".submitButton-getInTouch").attr("disabled", "true");
					$(".submitButton-getInTouch").text(i18nLib.localize("Message sent"));
					setTimeout(function () { $('.getInTouchSeccessMessage').addClass('hidden'); }, 6000);
				},
				error: function (xhr) { }
			});
		}
	});

	var lastBasketDataSent;
	if ($("#bookingTotalPrice").html() == i18nLib.localize("TOTAL EUR 0")) {
		$("#nextPage").hide();
	} else {
		$("#nextPage").show();
	}

	//Additional services on itinerary page
	$("#prevPage").show();
	if ((bookingDetails.pageFunction == "booking-itinerary") && bookingDetails.status == "CF") {
		if ($('.experience-modal-link[data-experience-added-previously=false][data-experience-is-selected=true]') &&
			$('.experience-modal-link[data-experience-added-previously=false][data-experience-is-selected=true]').length > 0) {
			$("#prevPage").hide();
		}
	}

	if ($("#pageFunctions").val() == "booking-itinerary" && $("#bookingStatus").val() == "CF") {
		$("#bookingRequest").keyup(function () {
			if ($("#bookingRequest").val().length > 0) {
				$("#nextPage").show();
			} else {
				//Check if there is any experience added in additional services.
				if ($('.experience-modal-link[data-experience-added-previously=false][data-experience-is-selected=true]') &&
					$('.experience-modal-link[data-experience-added-previously=false][data-experience-is-selected=true]').length == 0) {
					$("#nextPage").hide();
				}
			}
		});
	}

	window.showShareBookingModalClicked = false;
	function showShareBookingModal (clickEvent) {
		if (!window.showShareBookingModalClicked) { // Check lock
			window.showShareBookingModalClicked = true; // Start lock

			// Limit image size on mobile only
			if (window.matchMedia('(max-width: 575px)').matches) {
				var landscapeImage = $('#shareBookingModalLandscapeImage');
				var naturalHeight = landscapeImage.prop('naturalHeight');
				landscapeImage.parent().css({ 'maxHeight': naturalHeight + 'px' });
			}

			// Reset inputs
			$('#shareBookingModal :input').val('');
			$('#shareBookingModal input[type=checkbox]').prop('checked', false);

			// Reset visibility
			$('.share-booking__form').removeClass('hidden');
			$('.share-booking-success').removeClass('hidden');
			$('.share-booking__response').addClass('hidden');
			$('.share-booking-failure').addClass('hidden');

			// Open modal
			$('#shareBookingModal').modal('show');

			window.showShareBookingModalClicked = false; // Reset lock
		}

		return false;
	}

	window.sendShareBookingLinkClicked = false;
	function sendShareBookingLink (clickEvent) {
		if (!window.sendShareBookingLinkClicked) { // Check lock
			window.sendShareBookingLinkClicked = true; // Start lock

			var serviceUrl = $(this).data('service-url')
			var data = {
				bookingShareEmail: $('#bookingShareEmail').val(),
				bookingShareCustomText: $('#bookingShareCustomText').val(),
				bookingShareSubscription: $('#bookingShareSubscription').prop('checked'),
				bookingId: bookingDetails && bookingDetails.bookingId,
				bookingStep: bookingDetails && bookingDetails.pageFunction
			}

			// Email validation
			var emailRegex = /[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/g
			if (!data.bookingShareEmail || !data.bookingShareEmail.trim()) {
				window.sendShareBookingLinkClicked = false; // Reset lock
				return // Empty: no-action
			}
			var emailMatches = Array.from(data.bookingShareEmail.match(emailRegex))
			if (!emailMatches || emailMatches.length === 0) {
				window.sendShareBookingLinkClicked = false; // Reset lock
				return // Empty: no-action
			}

			$.ajax({
				url: serviceUrl,
				type: "POST",
				dataType: 'json',
				data: {
					data: JSON.stringify(data)
				}, // serializes the form's elements.
				success: function (data) {
					$('.share-booking__form').addClass('hidden');
					$('.share-booking__response').removeClass('hidden');
					window.sendShareBookingLinkClicked = false; // Reset lock
				},
				error: function (e) {
					$('.share-booking-success').addClass('hidden');
					$('.share-booking-failure').removeClass('hidden');
					$('.share-booking__form').addClass('hidden');
					$('.share-booking__response').removeClass('hidden');
					window.sendShareBookingLinkClicked = false; // Reset lock
				}
			})

			bookingDetails.extraNightSubmit = true;
			submitUrl = "reload";
			$("#bookingFormSubmit").submit();
		}
	}

	function basketUpdate (callLine) {
		var deferredForPromise = jQuery.Deferred(); // For optional promise use

		runningBasket = runningBasket + 1;
		var validRooms = bookingDetails.room.filter(function (roomConfig) {
			return roomConfig.type != null;
		});

		// log.info( callLine );

		if ($("#bookingUpdateUrl").val() &&
			(
				(
					bookingDetails.pageFunction == 'booking' && bookingDetails.startDate && bookingDetails.adults >= 1 &&
					(
						(
							bookingDetails.type == "tour" && bookingDetails.hotelCategory && validRooms.length >= 1 && bookingDetails.hotelCategory
						) || (
							bookingDetails.type == "experience"
						)
					)
				) || (
					['booking-itinerary', 'booking-contact', 'booking-summary', 'booking-payment', 'my-booking'].indexOf(bookingDetails.pageFunction) != -1
				)
			)
		) {

			$("#booking-basket").removeClass("hidden");
			$(".basket--price").removeClass("hidden");
			$(".currency_converter_box").removeClass("hidden");

			if (JSON.stringify(bookingDetails) != lastBasketDataSent) {

				bookingDetails.getBasket = true;

				// Old basket
				$("#basketContainer .basket--description").addClass("hidden");
				$("#basketContainer .loading").removeClass("hidden");


				// New basket
				// $("#sidepanel-body .loading").removeClass("hidden");
				(() => {
					$("#global-overlay").removeClass("hidden").removeClassByPrefix('hidden-');
					$("#global-spinner").removeClass("hidden").removeClassByPrefix('hidden-');
				})()


				if ($(".hotel-category--name") && $(".hotel-category--name").length > 0) {
					$(".hotel-category--name").hide();
					$(".hotel--category--choose .hotel--category--choose--wrap .loading-spinner").removeClass("hidden");
				}

				// Send updateTimer to backend
				bookingDetails.previousRequestTime = sessionStorage.getItem('bookingUpdatePreviousRequestTime')

				$.ajax({
					url: $("#bookingUpdateUrl").val(),
					type: "POST",
					dataType: 'json',
					data: {
						data: JSON.stringify(bookingDetails)
					}, // serializes the form's elements.
					success: function (data) {
						// Update local updateTime on frontend
						sessionStorage.setItem('bookingUpdatePreviousRequestTime', data.newRequestTime)

						// Scroll to error message from cancel
						setTimeout(function () {
							if ('URL' in window) {
								var currentUrl = new URL(window.location.href);
								var isCancel = currentUrl.searchParams.has('status', 'Cancel')
								var termsBookingSummary = $('.terms--wrap.terms-booking-summary')
								if (isCancel && termsBookingSummary && termsBookingSummary.length > 0) {
									const scrollTopTarget = termsBookingSummary.offset().top
									$('body, html').animate({
										scrollTop: parseInt(scrollTopTarget)
									}, 800, function () {
										window.location.hash = '#error-booking-summary'
									});
								}
							}
						}, 200);

						if (data && data.errors && data.errors.length > 0) {
							console.debug(JSON.stringify(bookingDetails));
							console.debug(JSON.stringify(data));

							data.errors.forEach(function (error) {
								var $errContainer = $(error.errorContainer);
								if ($errContainer.length) {
									if (!$errContainer.parent().hasClass('has-error')) {
										$errContainer.parent().addClass('has-error');
									}
									$errContainer.show();
									$errContainer.html(error.errorText);
								}
							});

							var focusElBasket = $(data.errors[0].errorFocus);
							var scrollYBasket = focusElBasket.length ? parseInt(focusElBasket.offset().top, 10) : 0;
							$('body, html').animate({
								scrollTop: scrollYBasket
							}, 800, function () {
								(() => {
									$("#global-overlay").addClass("hidden-L2674");
									$("#global-spinner").addClass("hidden-L2674");
								})()

								window.location.hash = data.errors[0].errorFocus;
							});
						}

						lastBasketDataSent = JSON.stringify(bookingDetails);
						var newBasketViewHeader
						var newBasketViewHeaderHidden

						var oldBasketView = $("#basketContainer #basketView")[0]
						if (oldBasketView) {
							$(oldBasketView).html($(data.basketView).find("#bookingBasket #basketView").html());
						} else {
							var newBasketView = $("#sidepanel-body")[0]
							var newBasketViewBanner = $("#sidepanel-price-banner")[0]
							newBasketViewHeader = $("#sidepanel-header")[0]
							newBasketViewHeaderHidden = $("#sidepanel-header-hidden")[0]

							newBasketView && $(newBasketView).html($(data.basketView).find("#sidepanel-body").html());
							newBasketViewBanner && $(newBasketViewBanner).html($(data.basketView).find("#sidepanel-price-banner").html());
							newBasketViewHeaderHidden && $(newBasketViewHeaderHidden).html($(data.basketView).find("#sidepanel-header").html());
						}

						// ShareBooking-Modal
						window.showShareBookingModalClicked = false;
						$('.shareBookingModalLink').off('click', showShareBookingModal);
						$('.shareBookingModalLink').on('click', showShareBookingModal);

						window.sendShareBookingLinkClicked = false;
						$('#bookingShareLinkSendBtn').off('click', sendShareBookingLink);
						$('#bookingShareLinkSendBtn').on('click', sendShareBookingLink);

						// currencyConversionLib.listenCurrency();

						// Deferred notification
						deferredForPromise.resolve({ data }) // For optional promise use

						for (var hotelCategory in data.categoryPrices) {
							if (data.categoryPrices[hotelCategory] && data.categoryPrices[hotelCategory].endsWith("EUR 0")) {
								$("#" + hotelCategory + "_price").html(data.categoryPrices[hotelCategory].replace("EUR 0", i18nLib.localize("Not Available")));
								$("[name='hotelCategory'][data-hotel-category='" + hotelCategory + "']").attr("disabled", true)
								$("label [data-hotel-category='" + hotelCategory + "']").parent().addClass("disabled");
							} else {
								$("#" + hotelCategory + "_price").html(data.categoryPrices[hotelCategory]);
								$("#" + hotelCategory + "_price").data('originalPriceText', data.categoryPrices[hotelCategory]);
								$("label [data-hotel-category='" + hotelCategory + "']").parent().removeClass("disabled");
								$("[name='hotelCategory'][data-hotel-category='" + hotelCategory + "']").removeAttr("disabled")
							}
						}

						if ($(".hotel-category--name") && $(".hotel-category--name").length > 0) {
							$(".hotel-category--name").show();
							$(".hotel--category--choose .hotel--category--choose--wrap .loading-spinner").addClass("hidden");
						}

						if ($(".numbers--rooms--text") && $(".numbers--rooms--text").length > 0) {
							if (data.roomsPrice && data.roomsPrice.length > 0 &&
								$(".numbers--rooms--text").html() != data.roomsPrice) {
								setTimeout(function () {
									$(".numbers--rooms .loading-spinner").addClass("hidden");
									$(".numbers--rooms--text").html(data.roomsPrice);
								}, 500, this);
								$(".numbers--rooms--text").html("")
								$(".numbers--rooms .loading-spinner").removeClass("hidden");
							}
						}

						if ($("#bookingTotalPrice").html() == i18nLib.localize("TOTAL EUR 0")) {
							$("#nextPage").hide();
						} else {
							if ($("#nextPage").length) {
								$("#nextPage").show();
							} else {
								$('<button type="submit" class="button button-green" name="nextPage" id="nextPage">' + $("#nextPageUrl").data("next-label") + "</button>").appendTo("#bookingFormSubmit")
								$("#nextPage").val($("#nextPageUrl").val());
							}

							//Check status of booking and hide nextPage button
							if (bookingDetails.status == "CF" && (!bookingDetails.addedExperiences || !data.addedExperiences) &&
								bookingDetails.pageFunction == "booking-itinerary") {
								$("#nextPage").hide();
							}
						}

						var updateCurrencies = function () {
							var bookingPageLayoutContainer = $("#booking-page-layout")
							// Global functions from js/authentic/exchangeCurrencies.js
							var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
							if (exchangeRateCurrency && bookingPageLayoutContainer[0]) {
								window.switchExchangeRateCurrency(bookingPageLayoutContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
							}
						}

						var moveSidepanelHeader = function () {
							if (newBasketViewHeader && newBasketViewHeaderHidden) {
								var processedHtml = $(newBasketViewHeaderHidden).html()
								$(newBasketViewHeaderHidden).html('')
								$(newBasketViewHeader).html(processedHtml)
							}
						}

						// Guarantee the execution after the new html were placed
						setTimeout(updateCurrencies, 100)
						setTimeout(updateCurrencies, 250)
						setTimeout(updateCurrencies, 500)
						setTimeout(moveSidepanelHeader, 700)
						setTimeout(updateCurrencies, 1000)
						setTimeout(updateCurrencies, 2500)
						setTimeout(updateCurrencies, 5000)

						//After all processing, trigger update event to bubble-up on DOM tree
						$("#basketContainer").trigger("bookingUpdate");
						runSidepanelEvents();

						// Old basket
						$("#basketContainer .basket--description").removeClass("hidden");
						$("#basketContainer .loading").addClass("hidden");

						// New basket
						$("#sidepanel-body .loading").addClass("hidden");
						(() => {
							$("#global-overlay").addClass("hidden-L2674");
							$("#global-spinner").addClass("hidden-L2674");
						})()
					},
					error: function (xhr) {
						(() => {
							$("#global-overlay").addClass("hidden-L2674");
							$("#global-spinner").addClass("hidden-L2674");
						})()
						$("#basketContainer .loading").addClass("hidden");
						$("#basketView").append("<strong class='help-block with-errors'>" + i18nLib.localize("Something went wrong! Please, contact our team.") + "</strong>");

						deferredForPromise.reject({ xhr }) // For optional promise use
					}
				});
			}
		}
		return deferredForPromise.promise() // For optional promise use
	}

	// [AS-332] Disable remove buttons on experiences already purchased
	if ($("#bookingStatus").val() == "CF")
		$("a[data-experience-added-previously='true']").addClass("experience-a-disabled");

	$(".experience-modal-link").on('click', function (e) {
		var $invoker = $(this);

		// [AS-332] Disable remove buttons on experiences already purchased
		if (($("#bookingStatus").val() == "CF") && $invoker.attr("data-experience-added-previously") == "true") {
			e.preventDefault();
			return false;
		}

		if ($invoker.attr('data-experience-is-selected') == "true") {
			$invoker.attr("data-experience-is-selected", "false");
			$invoker.html(i18nLib.localize("Add"));
			e.stopPropagation();

			var removeExperienceGtmEvent = function (/*data*/) {

				var experienceId = $invoker.data('experienceId')
				var basketAnalyticalSummary = window.basketAnalyticalSummary || {}

				if (!experienceId || !Array.isArray(basketAnalyticalSummary.basket)) {
					// No basket or empty experience
					return
				}

				var basketData = basketAnalyticalSummary.basket.filter(function (item) {
					return (
						item.experienceId === String(experienceId).replace(/-/g, '') ||
						item.experienceId === experienceId
					)
				})[0] || {}
				var price = parseInt((basketData.priceLabelFormat || '').replace(/\s+/g, '')) || 0
				var experienceTimestamp = parseInt(basketData.experienceTimestamp)
				var experienceDate = moment(experienceTimestamp ? new Date(experienceTimestamp) : new Date())

				var getExperiencePrice = (function (closurePrice) {
					return function () { return closurePrice }
				})(price);
				var getExperienceStartMonth = (function (closureExperienceDate) {
					return function () {
						var currentLocale = closureExperienceDate.locale();
						var englishMonth = closureExperienceDate.locale('en').format('MMMM YYYY');
						return closureExperienceDate.locale(currentLocale) && englishMonth;
					}
				})(experienceDate);

				var model = {
					isExperience: true,
					getExperiencePrice: window.getExperiencePrice || getExperiencePrice,
					getExperienceStartMonth: window.getExperienceStartMonth || getExperienceStartMonth,
					getExperienceIs65Days: window.getExperienceIs65Days,
					experienceAnalyticalData: {
						experienceId: experienceId,
						experienceTitle: $invoker.data('analyticalExperienceTitle') || basketData.label.split(/\s*[\uFE63\uFF08\uFF09]+\s*/)[1],
						currency: basketData.currencyLabel || (basketData.price || '').split(/\s+/g)[0],
						price: price,
						season: basketAnalyticalSummary.season || $invoker.data('analyticalExperienceSeason'),
						destination: $invoker.data('analyticalExperienceDestination'),
						experienceType: $invoker.data('analyticalExperienceType')
					}
				}

				gtm.withCart()
					.removeFromCart(model)
					.push();
			};

			// Run before the bookingUpdate
			removeExperienceGtmEvent();

			itineraryUpdate($invoker, 2323);
			basketUpdate(988);

			if (($invoker.attr("data-experience-overnight") == "true" || $invoker.attr("data-experience-roomupgrade") == "true") && $invoker.attr("data-experience-tax-type") == "room-based") {
				sessionStorage.setItem('hash', $invoker.attr("data-hash-day")); /*This is to put the hash on url to open this itinerary accordion when reload*/
				sessionStorage.setItem('scrollTop', 'hash');
				var scrollTopPosition = sessionStorage.getItem('scrollTop');
				// submitUrl = $("#itineraryPageUrl").val();
				submitUrl = "reload";
				$("#bookingFormSubmit").submit();
			}

			return false;
		} else {
			$("#experienceForm_invoker").val($invoker.attr("id"));
			if ($invoker.data("experience-is-selected")) {
				$("#experienceFormSubmit").attr("checked", "true");
			}
			$("#experienceForm_name").html($invoker.data("experience-title"));
			if ($invoker.data("experience-image")) {
				$("#experienceForm_image").attr("src", $invoker.data("experience-image"));
				$("#experienceForm_image").show();
			} else {
				$("#experienceForm_image").hide();
			}

			if ($invoker.attr("data-experience-adults-allowed") == "true") {
				$(".travelers--dropdown[data-booking-type='adults']").show();
				if ($invoker.attr("data-experience-adults") && $("#experienceForm_adults")) {
					$("#experienceForm_adults").val($invoker.attr("data-experience-adults"));
					$("#experienceAgePolicy_adults").html($invoker.attr("data-experience-adults-age-policy"));

					if ($invoker.attr("data-experience-tax-type") == "room-based") {
						$("#buyExperienceModal [data-booking-type='adults']li [type='button']").each(function () {
							$(this).attr("disabled", true);
						})
						$("#buyExperienceModal [data-booking-type='adults']li span.qtyminus").each(function () {
							$(this).addClass("hidden");
						})
						$("#buyExperienceModal [data-booking-type='adults']li span.qtyplus").each(function () {
							$(this).addClass("hidden");
						})
						$("#experienceForm_adults").val($("#experienceForm_adults").attr("max"));
					} else if ($invoker.attr("data-experience-tax-type") == "pax-based") {
						$("#buyExperienceModal [data-booking-type='adults']li [type='button']").each(function () {
							$(this).attr("disabled", false);
						})
						$("#buyExperienceModal [data-booking-type='adults']li span.qtyminus").each(function () {
							$(this).removeClass("hidden");
						})
						$("#buyExperienceModal [data-booking-type='adults']li span.qtyplus").each(function () {
							$(this).removeClass("hidden");
						})
						$("#experienceForm_adults").val($invoker.attr("data-experience-adults"));
					}
				}
			} else {
				$(".travelers--dropdown[data-booking-type='adults']").hide();
			}
			if ($invoker.attr("data-experience-children-allowed") == "true") {
				$(".travelers--dropdown[data-booking-type='children']").show();
				if ($invoker.attr("data-experience-children") && $("#experienceForm_children")) {
					$("#experienceAgePolicy_children").html($invoker.attr("data-experience-children-age-policy"));
					if ($invoker.attr("data-experience-tax-type") == "room-based") {
						$("#buyExperienceModal [data-booking-type='children']li [type='button']").each(function () {
							$(this).attr("disabled", true);
						})
						$("#buyExperienceModal [data-booking-type='children']li span.qtyminus").each(function () {
							$(this).addClass("hidden");
						})
						$("#buyExperienceModal [data-booking-type='children']li span.qtyplus").each(function () {
							$(this).addClass("hidden");
						})

						$("#experienceForm_children").val($("#experienceForm_children").attr("max"));
					} else if ($invoker.attr("data-experience-tax-type") == "pax-based") {
						$("#buyExperienceModal [data-booking-type='children']li [type='button']").each(function () {
							$(this).attr("disabled", false);
						})
						$("#buyExperienceModal [data-booking-type='children']li span.qtyminus").each(function () {
							$(this).removeClass("hidden");
						})
						$("#buyExperienceModal [data-booking-type='children']li span.qtyplus").each(function () {
							$(this).removeClass("hidden");
						})
						$("#experienceForm_children").val($invoker.attr("data-experience-children"));
					}
				}
			} else {
				$(".travelers--dropdown[data-booking-type='children']").hide();
			}
			if ($invoker.attr("data-experience-infants-allowed") == "true") {
				$(".travelers--dropdown[data-booking-type='infants']").show();
				if ($invoker.attr("data-experience-infants") && $("#experienceForm_infants")) {
					$("#experienceForm_infants").val($invoker.attr("data-experience-infants"))
					$("#experienceAgePolicy_infants").html($invoker.attr("data-experience-infants-age-policy"));
					if ($invoker.attr("data-experience-tax-type") == "room-based") {
						$("#buyExperienceModal [data-booking-type='infants']li [type='button']").each(function () {
							$(this).attr("disabled", true);
						})
						$("#buyExperienceModal [data-booking-type='infants']li span.qtyminus").each(function () {
							$(this).addClass("hidden");
						})
						$("#buyExperienceModal [data-booking-type='infants']li span.qtyplus").each(function () {
							$(this).addClass("hidden");
						})

						$("#experienceForm_infants").val($("#experienceForm_infants").attr("max"));
					} else if ($invoker.attr("data-experience-tax-type") == "pax-based") {
						$("#buyExperienceModal [data-booking-type='infants']li [type='button']").each(function () {
							$(this).attr("disabled", false);
						})
						$("#buyExperienceModal [data-booking-type='infants']li span.qtyminus").each(function () {
							$(this).removeClass("hidden");
						})
						$("#buyExperienceModal [data-booking-type='infants']li span.qtyplus").each(function () {
							$(this).removeClass("hidden");
						})
						$("#experienceForm_children").val($invoker.attr("data-experience-children"));
					}
				}
			} else {
				$(".travelers--dropdown[data-booking-type='infants']").hide();
			}
			if ($invoker.attr("data-experience-day-selector") && $invoker.attr("data-experience-day-selector") != "'null'") {
				var days = JSON.parse($invoker.attr("data-experience-day-selector").slice(1, -1).replace(/\\/g, ''));
				var dateTabs = "";
				var tabContents = "";
				var activeFlag = false;
				days.forEach(function (day, index) {

					var active = "";
					/*this condition is to put active just in the first valid day*/
					if (day.isValidForDate && day.isOpeningDateWeekday && !activeFlag) {
						activeFlag = true;
						active = "active"
					}

					dateTabs += '<li role="presentation" class="experience--date ' + active + " " + (!day.isValidForDate || !day.isOpeningDateWeekday || days.length == 1 ? ' disabled' : '') + (day.openingTimes.length == 0 ? ' no-content' : '') + '" data-day-number="' + day.dayLabel + '" data-day-date="' + day.date + '">';
					if (day.isValidForDate && day.isOpeningDateWeekday) {
						dateTabs += '<a class="experience--date-wrap" href="#dayTab' + index + '" role="tab" id="day' + index + '" data-toggle="tab" aria-controls="dayTab' + index + '">';
						dateTabs += '<span>' + i18nLib.localize('DAY') + '</span>';
						dateTabs += '<span>' + day.dayLabel + '</span>';
						dateTabs += '</a>';

						tabContents += '<div role="tabpanel" class="tab-pane ' + active + " " + ((day.openingTimes && day.openingTimes.length == 0) ? ' no-content' : '') + '" id="dayTab' + index + '" aria-labelledby="day' + index + '">';
						tabContents += '<div class="time--radios" data-toggle="buttons">';

						var experienceTitle = $invoker.data("experience-title").toLowerCase();
						var isOverNight = $invoker.data("experience-overnight");
						var isRoomUpgrade = $invoker.data("experience-roomupgrade");
						if (experienceTitle && (experienceTitle.indexOf("extra night") != -1 || isOverNight)) {
							var maxDuration = parseInt($invoker.data("experience-max-duration"));
							for (var i = 1; i <= maxDuration; i++) {
								var checkedAttr = (i == 1);
								tabContents += '<label class="btn ' + (checkedAttr ? 'active' : '') + '"> ';
								tabContents += '<input type="radio" name="selectedDuration" id="sD' + index + '_' + i + '" value="' + i + '" autocomplete="off" ' + (checkedAttr ? 'checked' : '') + '>';
								tabContents += '<span class="time--radio"></span>';
								tabContents += '<span>' + i + ' ' + i18nLib.localize('Extra ' + 'Night' + (i > 1 ? 's' : '')) + '</span>';
								tabContents += '</label>';
							}
						} else if (isRoomUpgrade) {
							var maxDuration = parseInt($invoker.data("experience-max-duration"));
							for (var i = 1; i <= (days.length - index); i++) {
								var checkedAttr = (i == 1);
								tabContents += '<label class="btn ' + (checkedAttr ? 'active' : '') + '"> ';
								tabContents += '<input type="radio" name="selectedDuration" id="sD' + index + '_' + i + '" value="' + i + '" autocomplete="off" ' + (checkedAttr ? 'checked' : '') + '>';
								tabContents += '<span class="time--radio"></span>';
								tabContents += '<span>' + i + ' ' + i18nLib.localize('Night' + (i > 1 ? 's' : '')) + '</span>';
								tabContents += '</label>';
							}
						} else {
							if (day.openingTimes) {
								day.openingTimes.forEach(function (openingTime, i) {
									//var checkedAttr = ((openingTime.startTime == $invoker.attr("data-experience-start-time") && (!openingTime.endTime || openingTime.endTime && openingTime.endTime == $invoker.attr("data-experience-end-time"))) || day.openingTimes.length == 1);
									var checkedAttr = (i == 0);
									tabContents += '<label class="btn ' + (checkedAttr ? 'active' : '') + '"> ';
									tabContents += '<input type="radio" name="selectedTime" id="sT' + index + '_' + i + '" value="' + openingTime.startTime + '" ' + (openingTime.endTime ? 'data-end-time="' + openingTime.endTime + '"' : "") + ' autocomplete="off" ' + (checkedAttr ? 'checked' : '') + '>';
									tabContents += '<span class="time--radio"></span>';
									tabContents += '<span>' + openingTime.label + '</span>';
									tabContents += '</label>';
								})
							}
						}

						tabContents += '</div>';
						tabContents += '</div>';

					} else {
						dateTabs += '<div class="experience--date-wrap">';
						dateTabs += '<span>' + i18nLib.localize('DAY') + '</span>';
						dateTabs += '<span>' + day.dayLabel + '</span>';
						dateTabs += '</div>';
					}

					dateTabs += '</li>';
				});
				if (!activeFlag) {
					$("#experienceFormSubmit").attr("disabled", "disabled");
					$("#experienceFormSubmit").addClass("disabled");
				} else {
					$("#experienceFormSubmit").removeAttr("disabled");
					$("#experienceFormSubmit").removeClass("disabled");
				}

				$("#experienceDateTabs").html(dateTabs);
				$("#experienceTabsContent").html(tabContents);

				$(".experience--date, .experience--date-wrap, .time--radios").on("click", function () {
					setTimeout(checkSubmitEnabled, 100, this);
				});

			} else {
				$("#experienceDateTabs").html("");
				$("#experienceTabsContent").html("");
			}
			$("#buyExperienceModal").modal("show");
		}
	});

	function checkSubmitEnabled (e) {

		var id = null;
		if ($(e).attr('aria-controls')) {
			id = $(e).attr('aria-controls');
		} else {
			if ($(e).parent().attr("id")) {
				id = $(e).parent().attr("id");
			}
		}

		if (id) {
			if ($("#" + id + " [name='selectedTime']").length > 0) {
				var isChecked = false;
				$("#" + id + " [name='selectedTime']").each(function (index, item) {
					var inputID = $(item).attr("id");

					if ($("#" + inputID).is(":checked") || $("#" + inputID).parent().hasClass('active')) {
						isChecked = true;
					}
				});

				if (isChecked) {
					setTimeout(function () {
						$("#experienceFormSubmit").removeAttr("disabled");
						$("#experienceFormSubmit").removeClass("disabled");
					}, 200)
				}
			}

			if ($("#" + id + " [name='selectedDuration']").length > 0) {
				var isChecked = false;
				$("#" + id + " [name='selectedDuration']").each(function (index, item) {
					var inputID = $(item).attr("id");

					if ($("#" + inputID).is(":checked") || $("#" + inputID).parent().hasClass('active')) {
						isChecked = true;
					}
				});

				if (isChecked) {
					setTimeout(function () {
						$("#experienceFormSubmit").removeAttr("disabled");
						$("#experienceFormSubmit").removeClass("disabled");
					}, 100)
				} else {
					$("#experienceFormSubmit").attr("disabled", "disabled");
					$("#experienceFormSubmit").addClass("disabled");
				}
			}

		}
	}

	var $invoker;
	$(document).on("click", "#experienceFormSubmit", function (e) {

		$invoker = $("#" + $("#experienceForm_invoker").val());

		$invoker.attr("data-experience-is-selected", "true");
		$invoker.html(i18nLib.localize("Remove"));
		$invoker.attr("data-experience-adults", ($("#experienceForm_adults:visible").val() || 1));
		$invoker.attr("data-experience-children", ($("#experienceForm_children:visible").val() || 0));
		$invoker.attr("data-experience-infants", ($("#experienceForm_infants:visible").val() || 0));
		$invoker.attr("data-experience-selected-date", $(".experience--date.active").data("day-date"));

		var tabPanelId = $("#experienceDateTabs .experience--date.active .experience--date-wrap").attr("href");

		$invoker.attr("data-experience-start-time", ($(tabPanelId + " .btn.active [name='selectedTime']") ? $(tabPanelId + " .btn.active [name='selectedTime']").val() : ""))
		$invoker.attr("data-experience-end-time", ($(tabPanelId + " .btn.active [name='selectedTime']") && $(tabPanelId + " .btn.active [name='selectedTime']").data("end-time") ? $(tabPanelId + " .btn.active [name='selectedTime']").data("end-time") : ""));

		//$invoker.attr("data-experience-start-time", ($("#buyExperienceModal .tab-pane.active [name='selectedTime']:checked") ? $("#buyExperienceModal .tab-pane.active [name='selectedTime']:checked").val() : ""))
		//$invoker.attr("data-experience-end-time", ($("#buyExperienceModal .tab-pane.active [name='selectedTime']:checked") && $("#buyExperienceModal .tab-pane.active [name='selectedTime']:checked").data("end-time") ? $("#buyExperienceModal .tab-pane.active [name='selectedTime']:checked").data("end-time") : ""))

		if ($("#buyExperienceModal .tab-pane.active [name='selectedDuration']").length) {
			$invoker.attr("data-experience-duration", ($(tabPanelId + " .btn.active [name='selectedDuration']") ? $(tabPanelId + " .btn.active [name='selectedDuration']").val() : ""));
			//$invoker.attr("data-experience-duration", ($("#buyExperienceModal .tab-pane.active [name='selectedDuration']:checked") ? $("#buyExperienceModal .tab-pane.active [name='selectedDuration']:checked").val() : ""));
			$invoker.attr("data-experience-start-time", "00:00")
			$invoker.attr("data-experience-end-time", "23:59")
		}

		//Compute shift days
		var parentElement = $invoker.parents("[data-booking-itinerary-day]").eq(0);
		var dayElement = $("#tour_day_" + parentElement.data("booking-itinerary-day"));
		var inputDay = dayElement.data("booking-day-index");
		var startDate = moment(bookingDetails.itinerary[parseInt(inputDay)].startDate, "DD.MM.YYYY");
		var selectedDate = moment($invoker.attr("data-experience-selected-date"), "YYYY-MM-DD");
		$invoker.attr("data-experience-shift-days", selectedDate.diff(startDate, "days"));

		$("#experienceForm_invoker").val("")
		$("#experienceForm_adults").val("");
		$("#experienceForm_children").val("");
		$("#experienceForm_infants").val("");
		$("#experienceDateTabs").html("");
		$("#experienceTabsContent").html("");

		itineraryUpdate($invoker, 2631);

		//basketUpdate(1113);

		if ($invoker && (bookingDetails.status == "CF")) {
			bookingDetails.addedExperiences = true;
		}

		if (($invoker.attr("data-experience-overnight") == "true" || $invoker.attr("data-experience-roomupgrade") == "true") && $invoker.attr("data-experience-tax-type") == "room-based") {
			sessionStorage.setItem('hash', $invoker.attr("data-hash-day")); /*This is to put the hash on url to open this itinerary accordion when reload*/
			var hashPosition = getAbsolutePosition(`[data-hash-day="${sessionStorage.getItem('hash')}"]`);
			sessionStorage.setItem('scrollTop', 'hash');
			var scrollTopPosition = sessionStorage.getItem('scrollTop');

			// submitUrl = $("#itineraryPageUrl").val();
			submitUrl = "reload";

			$("#bookingFormSubmit").submit();
			// addExperienceGtmEvent($invoker)() // Since the page will reload this event will not work
		} else {
			basketUpdate(1113).done(addExperienceGtmEvent($invoker));
		}

		$("#buyExperienceModal .modal--close-button").click();
	})

	if (bookingDetails.pageFunction == "booking-itinerary") {
		$(document).ready(function () {
			// var sessionScrollTop = sessionStorage.getItem('scrollTop')

			// if (isNotNullNorUndefined(sessionScrollTop)) {
			// 	if (sessionScrollTop === 'hash') {
			// 		var hashPosition = getAbsolutePosition(`[data-hash-day="${sessionStorage.getItem('hash')}"]`);
			// 		sessionScrollTop = (hashPosition && hashPosition.top) || 0;
			// 	}
			// 	$(window).scrollTop(sessionScrollTop > 1000 ? 500 : sessionScrollTop);
			// 	sessionStorage.removeItem('scrollTop');
			// }
		});
	}

	$("#printButton").on("click", function (e) { e.preventDefault(); window.print(); });
});

/**
 * @param {string} currentStep
 */
function purchaseGtmEvent (currentStep) {
	var basketAnalyticalSummary = window.basketAnalyticalSummary || {}

	if (!Array.isArray(basketAnalyticalSummary.basket)) {
		console.debug('No basket')
		console.trace('purchaseGtmEvent')
		return
	}

	var basketProducts = basketAnalyticalSummary.basket.filter(function (item) { return item.experienceId || item.tourId })
	var offers = basketAnalyticalSummary.basket.filter(function (item) { return item.basketType === 'offer' })
	var serviceType = basketAnalyticalSummary.tourplanServiceType || $('#tourplanServiceType').val()
	var discount = (Array.isArray(offers) && offers[0] && offers[0].numericPrice) || null
	var gtmCart = gtm.withCart()
	var startDateTime = $("#bookingTourStartDate").val()
	var endDataTime = $("#bookingEndDate").val()
	var transactionId = $('#bookingId').val()
	var revenue = $('#bookingTotalPrice').data('totalPrice') || $('#bookingTotalPrice').text().replace(/[\s]+/g, '')
	revenue = parseFloat(revenue).toFixed()
	var affiliation = window.location.hostname // current domain

	handleBasketProducts(basketProducts, gtmCart, (function (model) {
		gtmCart.purchaseCart({ currentStep, transactionId, revenue, affiliation, startDateTime, endDataTime, discount, serviceType }, model)
	}))

	// Push all products from basket
	gtmCart.push()
}

/**
 * @param {string} currentStep
 */
function checkoutGtmEvent (currentStep) {
	var basketAnalyticalSummary = window.basketAnalyticalSummary || {}

	if (!Array.isArray(basketAnalyticalSummary.basket)) {
		console.debug('No basket')
		console.trace('checkoutGtmEvent')
		return
	}

	var basketProducts = basketAnalyticalSummary.basket.filter(function (item) { return item.experienceId || item.tourId })
	var gtmCart = gtm.withCart()

	handleBasketProducts(basketProducts, gtmCart, (function (model) {
		gtmCart.checkoutCart({ currentStep }, model)
	}))

	// Push all products from basket
	gtmCart.push()
}

function clone (obj) {
	if (!obj) return obj
	return JSON.parse(JSON.stringify(obj))
}

/**
 * Process products for checkout or purchase events
 * @param {[]} basketProducts
 * @param {object} gtmCart
 * @param {function} modelCallback
 */
function handleBasketProducts (basketProducts, gtmCart, modelCallback) {
	if (basketProducts.length === 0) {
		// Run at least once, with empty model
		modelCallback(null)
	} else {
		var experienceProducts = []
		var tourProducts = {}
		var toursOrderTotalPrice = 0

		// Consolidate tour prices
		basketProducts.reduce((acc, basketData) => {
			basketData = clone(basketData)
			basketData.numericPrice = parseInt((basketData.priceLabelFormat || '').replace(/\s+/g, '')) || 0
			if (basketData.tourId && ['extraNight', 'extra-night', 'experience', 'offer'].indexOf(basketData.basketType) === -1) {
				toursOrderTotalPrice += basketData.numericPrice
				if (!tourProducts[basketData.tourId]) {
					tourProducts[basketData.tourId] = basketData
				} else {
					tourProducts[basketData.tourId].numericPrice += basketData.numericPrice
				}
			} else if (basketData.basketType === 'offer') {
				toursOrderTotalPrice += basketData.numericPrice
			} else {
				experienceProducts.push(basketData)
			}
			return acc
		}, tourProducts)
		// Update basket products array with consolidated objects
		basketProducts = [].concat(experienceProducts, Object.values(tourProducts))

		// Process basket products
		basketProducts.forEach(basketData => {
			var price = (typeof basketData.numericPrice === 'number') ? basketData.numericPrice.toFixed() : basketData.numericPrice

			if (basketData.tourId && ['extraNight', 'extra-night', 'experience', 'offer'].indexOf(basketData.basketType) === -1) {
				var tourTimestamp = parseInt(basketData.tourTimestamp)
				var tourDate = moment(tourTimestamp ? new Date(tourTimestamp) : new Date())

				var getTourPrice = (function (closurePrice) {
					return function () { return closurePrice }
				})(price);
				var getTourStartMonth = (function (closureTourDate) {
					return function () {
						var currentLocale = closureTourDate.locale();
						var englishMonth = closureTourDate.locale('en').format('MMMM YYYY');
						return closureTourDate.locale(currentLocale) && englishMonth;
					}
				})(tourDate);

				var model = {
					isTour: true,
					toursOrderTotalPrice,
					getTourPrice: window.getTourPrice || getTourPrice,
					getTourStartMonth: window.getTourStartMonth || getTourStartMonth,
					getTourIs65Days: window.getTourIs65Days,
					tourAnalyticalData: {
						tourId: basketData.tourId,
						tourTitle: basketAnalyticalSummary.basketTitle,
						currency: basketData.currencyLabel || (basketData.price || '').split(/\s+/g)[0],
						price: price,
						season: basketAnalyticalSummary.season,
						destination: basketAnalyticalSummary.destination,
						tourType: basketAnalyticalSummary.tourType,
						roomAdults: basketData.tourTravelers.adults,
						roomChildren: basketData.tourTravelers.children,
						roomInfants: basketData.tourTravelers.infants,
					}
				}
			} else if (basketData.basketType !== 'offer') {
				var experienceTimestamp = parseInt(basketData.experienceTimestamp)
				var experienceDate = moment(experienceTimestamp ? new Date(experienceTimestamp) : new Date())

				var getExperiencePrice = (function (closurePrice) {
					return function () { return closurePrice }
				})(price);
				var getExperienceStartMonth = (function (closureExperienceDate) {
					return function () {
						var currentLocale = closureExperienceDate.locale();
						var englishMonth = closureExperienceDate.locale('en').format('MMMM YYYY');
						return closureExperienceDate.locale(currentLocale) && englishMonth;
					}
				})(experienceDate);
				var experienceData = basketData.experienceAnalyticalData || {}
				var travelers = basketData.experienceTravelers || {}

				var model = {
					isExperience: true,
					toursOrderTotalPrice,
					getExperiencePrice: window.getExperiencePrice || getExperiencePrice,
					getExperienceStartMonth: window.getExperienceStartMonth || getExperienceStartMonth,
					getExperienceIs65Days: window.getExperienceIs65Days,
					experienceAnalyticalData: {
						experienceId: basketData.experienceId || basketData.tourId /* tourId for inline extra-nights */,
						experienceTitle: basketData.label.split(/\s*[\uFE63\uFF08\uFF09]+\s*/)[1],
						currency: basketData.currencyLabel || (basketData.price || '').split(/\s+/g)[0],
						price: price,
						season: experienceData.season || basketAnalyticalSummary.season,
						destination: experienceData.destination || basketAnalyticalSummary.destination,
						experienceType: experienceData.experienceType || basketAnalyticalSummary.tourType,
						adults: travelers.adults,
						children: travelers.children,
						infants: travelers.infants
					}
				}
			}

			modelCallback(model)
		})
	}
}

/**
 * @param {JQuery} $invoker
 * @returns {function}
 */
function addExperienceGtmEvent ($invoker) {
	return function (/*data*/) {
		var experienceId = $invoker.data('experienceId')
		var basketAnalyticalSummary = window.basketAnalyticalSummary || {}

		var noExperience, noBasket
		if ((noExperience = !experienceId) || (noBasket = !Array.isArray(basketAnalyticalSummary.basket))) {
			console.debug(noExperience && noBasket ? 'No basket and empty experience' : (noBasket ? 'No basket' : 'Empty experience'))
			return
		}

		var basketData = basketAnalyticalSummary.basket.filter(function (item) {
			return (
				item.experienceId === String(experienceId).replace(/-/g, '') ||
				item.experienceId === experienceId
			)
		})[0] || {}
		var price = parseInt((basketData.priceLabelFormat || '').replace(/\s+/g, '')) || 0
		var experienceTimestamp = parseInt(basketData.experienceTimestamp)
		var experienceDate = moment(experienceTimestamp ? new Date(experienceTimestamp) : new Date())

		var getExperiencePrice = (function (closurePrice) {
			return function () { return closurePrice }
		})(price);
		var getExperienceStartMonth = (function (closureExperienceDate) {
			return function () {
				var currentLocale = closureExperienceDate.locale();
				var englishMonth = closureExperienceDate.locale('en').format('MMMM YYYY');
				return closureExperienceDate.locale(currentLocale) && englishMonth;
			}
		})(experienceDate);

		var model = {
			isExperience: true,
			getExperiencePrice: window.getExperiencePrice || getExperiencePrice,
			getExperienceStartMonth: window.getExperienceStartMonth || getExperienceStartMonth,
			getExperienceIs65Days: window.getExperienceIs65Days,
			experienceAnalyticalData: {
				experienceId: experienceId,
				experienceTitle: $invoker.data('analyticalExperienceTitle') || basketData.label.split(/\s*[\uFE63\uFF08\uFF09]+\s*/)[1],
				currency: basketData.currencyLabel || (basketData.price || '').split(/\s+/g)[0],
				price: price,
				season: basketAnalyticalSummary.season || $invoker.data('analyticalExperienceSeason'),
				destination: $invoker.data('analyticalExperienceDestination'),
				experienceType: $invoker.data('analyticalExperienceType')
			}
		}

		gtm.withCart()
			.addToCart(model)
			.push();
	}
}

/**
 * Removes a class starting with a given prefix from an HTML element
 * @this {HTMLElement} htmlElement - The element from which to remove the class
 * @param {string} classPrefix - The prefix of the class to remove
 */
function removeClassByPrefix (classPrefix) {
	if (!classPrefix) return this;

	this.each(function () {
		const classes = $(this).attr('class').split(' ').filter(className => !className.startsWith(classPrefix));
		$(this).attr('class', classes.join(' '));
	});

	return this;
}

function isNullOrUndefined (value) {
	return value === null || value === undefined;
}

function isNotNullNorUndefined (value) {
	return !isNullOrUndefined(value);
}

function getAbsolutePosition (selector) {
	var element = document.querySelector(selector);
	if (!element) return null;

	var rect = element.getBoundingClientRect();
	var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	};
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/booking.js